<template>

  <v-container grid-list-xl fluid class="background-grey">

        <HelperRecepcionista :lista-help="listaHelp" :dialog-help="dialogHelp" :descricao-dialogo="''"
          @alterar-dialog-help="alterarDialogHelp" />

     <v-row class="pl-1">
  <v-col cols="3" md="3" sm="3" class="mr-0 pr-0">
    <!-- Cabeçalho centralizado -->
    <v-card class="mb-3" flat>
      <v-row justify="center" align="center" class="display-1 py-2">
        <div id="font">Simples</div>
        <div id="font" class="primary--text ml-1">Medic</div>
      </v-row>
    </v-card>

    <!-- Container principal com alinhamento consistente -->
    <v-card class="rounded-lg pa-1" outlined>
      <!-- Card de perfil -->
      <v-card class="mb-2" flat>
        <v-list>
          <v-list-item>
            <v-list-item-avatar class="ml-3">
              <v-avatar color="primary" size="56">
                <img v-if="user.avatar" :src="user.avatar" />
                <span v-else class="white--text headline">{{ user.nome.charAt(0) }}</span>
              </v-avatar>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title class="title">{{ nomeFormatado(user.nome) }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-card>
      <v-list dense>
      <v-subheader>Unidades</v-subheader>
      <v-list-item-group
        v-model="selectedUnidade"
        color="primary"
      >
        <v-list-item
          v-for="(unidade, i) in unidades"
          :key="i"
        >
          <v-list-item-icon>
            <v-icon>add_location</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title v-text="unidade.nomeUnidade"></v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-item-group>
    </v-list>
      <!-- Cards de informações alinhados -->
      <v-card outlined class="mb-1" @click="verificaVezChamada()">
        <v-card flat class="mb-1 pa-3 rounded-lg">
          <v-row no-gutters align="center">
            <v-col cols="4" class="text-center">
              <strong class="subtitle-1">Local:</strong>
            </v-col>
            <v-col cols="1" class="text-center">
              <v-divider vertical />
            </v-col>
            <v-col cols="7" class="text-center">
              <v-card outlined>
                <strong>{{ nomeLocal || 'Não selecionado' }}</strong>
              </v-card>
            </v-col>
          </v-row>
        </v-card>
        <v-divider />
        <v-card flat class="mb-1 pa-3 rounded-lg" :disabled="!nomeLocal">
          <v-row no-gutters align="center">
            <v-col cols="5" class="text-center">
              <strong class="subtitle-1">Guichê:</strong>
            </v-col>
            <v-col cols="1" class="text-center">
              <v-divider vertical />
            </v-col>
            <v-col cols="6" class="text-center">
              <v-card outlined>
                <strong>
                  {{ guiche && guiche !== '?' ? guiche : '?' }}
                </strong>
              </v-card>
            </v-col>
          </v-row>
        </v-card>
        <v-divider />
        <!-- Card de seleção de serviços -->
        <v-card flat class="mb-3 pa-3 rounded-lg text-center" @click="exibirDialogServicosAtendente()">
          <v-tooltip right>
            <template v-slot:activator="{ on, attrs }">
              <div v-bind="attrs" v-on="on">
                <strong class="subtitle-1">Selecionar serviços</strong>
              </div>
            </template>
            <span>
              <template v-for="(item) in listaServicosRecepcionista">
                <div v-if="item.status" :key="item.title">{{ item.nomeEspecialidade }}</div>
              </template>
            </span>
          </v-tooltip>
        </v-card>
      </v-card>
      <!-- Estatísticas -->
      <v-card class="mb-3" outlined>
        <v-list dense>
          <v-list-item>
            <v-list-item-content>
              <v-row no-gutters align="center">
                <v-col cols="9" class="text-center">
                  <span class="body-2">Pacientes não chamados:</span>
                </v-col>
                <v-col cols="1">
                  <v-divider vertical />
                </v-col>
                <v-col cols="2" class="text-center">
                  <strong class="subtitle-1 primary--text">
                    {{ listaPrioridade.length + listaSemPrioridade.length }}
                  </strong>
                </v-col>
              </v-row>
            </v-list-item-content>
          </v-list-item>

          <v-divider />

          <v-list-item>
            <v-list-item-content>
              <v-row no-gutters align="center">
                <v-col cols="9" class="text-center">
                  <span class="body-2">Atendimentos realizados:</span>
                </v-col>
                <v-col cols="1">
                  <v-divider vertical />
                </v-col>
                <v-col cols="2" class="text-center">
                  <strong class="subtitle-1 primary--text">
                    {{ quantAtendimentos }}
                  </strong>
                </v-col>
              </v-row>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-card>

      <!-- Lista de médicos -->
      <lista-medicos class="mt-2" @medicoSelecionado="selecionarMedico" :medico="medico" />

      <v-card class="mt-2 rounded-lg" outlined>
        <v-list dense>
          <!-- Navigation Items -->
          <v-list-item v-for="(item, i) in items" :key="i" @click="setDialog(item.id)">
            <v-list-item-icon class="mx-auto">
              <v-icon color="green" left>{{ item.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <!-- Help Item -->
          <v-list-item @click="retornarHelp()">
            <v-list-item-icon class="mx-auto">
              <v-icon color="blue" left>fas fa-info</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Ajuda</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <!-- Logout Item -->
          <v-list-item @click="logout()" class="py-2">
            <v-list-item-icon class="mx-auto">
              <v-icon color="red" left>fas fa-sign-out-alt</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Sair</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-card>
    </v-card>
  </v-col>
  <!-- FIM BARRA LATERAL -->
  <v-col cols="9" md="9" sm="9"  v-if="isAtendimentoComp && medico == null">
    <v-fade-transition hide-on-leave>
      <v-card outlined class="pa-2 mr-6">
        <atendimento :servicosOs="servicos" :servicos="atendimento.servicos" :my-atendimento="atendimento"
          :em-chamada="guiche == 0 || !atendimento.codigo.length || iniciouAtendimento || desabilitaBotaoChamar"
          :color-text="codigoColor.textColor" :color="'grey darken-1'"
          :dialogCronometroAtendimento="dialogCronometroAtendimento" :tempoAtendimento="tempoAtendimento"
          :dialogOs="dialogOs" :servicosOsLoading="servicosOsLoading" :TextoModalHeadline="TextoModalHeadline"
          :dialogCancelarEsperaAtendimento="dialogCancelarEsperaAtendimento"
          :isCancelarAtendimento="isCancelarAtendimento" :btnOp="!fezChamada && !isPendente"
          :servicosOsOk="servicosOsOk" :servicosOsErro="servicosOsErro"
          :listaTransferirAtendimentosMedicos="listaTransferirAtendimentosMedicos"
          :dialogOrdenarExames="dialogOrdenarExames" :nomePaciente="nomePaciente"
          :listaExamesNaoEncontrados="listaExamesNaoEncontrados" :listaServicosAgrupados="listaServicosAgrupados"
          :dialogCadastrarPreferencia="dialogCadastrarPreferencia"
          :alertPreferenciaObrigatoria="alertPreferenciaObrigatoria" :isNumero="isNumero"
          :numeroPaciente="numeroPaciente" :mask="mask" :erroNumero="erroNumero" :step="step"
          :dialogProximoAtendimento="dialogProximoAtendimento" :mensagemProximaUnidade="mensagemProximaUnidade"
          :mensagemIdProximaUnidade="mensagemIdProximaUnidade" :consultas="consultas"
          :mensagemProximoLocalDialog="mensagemProximoLocalDialog" :nomeExame="nomeExame"
          :nomeEspecialidade="nomeEspecialidade" :desabilitaBotaoAdicionar="desabilitaBotaoAdicionar"
          :mLocais="mLocais" @novaConsulta="novaConsulta" @addUnidadesServicos="addUnidadesServicos"
          @verificarBotaoAdicionar="verificarBotaoAdicionar" @voltar="isAtendimentoComp = false"
          @mudarDialogCancelarEsperaAtendimento="mudarDialogCancelarEsperaAtendimento(elemento)"
          @my-col="setColunas" @chamar="fazerChamada" @iniciarAtendimento="iniciarAtendimento"
          @naoCompareceu="chamadaNaoAtendida" @encerrarCronometroAtendimento="encerrarCronometroAtendimento"
          @confirmarCancelarEsperaAtendimento="confirmarCancelarEsperaAtendimento"
          @retornarServicosOs="retornarServicosOs" @esperaAtendimento="esperaAtendimento"
          @cancelarAtendimento="cancelarAtendimento" @fecharAlertErro="fecharAlertErro"
          @transferirAtendimento="transferirAtendimento" @exibirCardOS="exibirCardOS" @fecharCardOS="fecharCardOS"
          @somarStep="somarStep" @decrementarStep="decrementarStep"
          @organizarServicosEnviados="organizarServicosEnviados" @proximoAtendimento="proximoAtendimento"
          @setarUnidade="setarUnidade" @alteraIsNumero="alteraIsNumero" @alteraNumeroPaciente="alteraNumeroPaciente"
          @voltarOrdenarExames="voltarOrdenarExames"
          @encerrarAtendimentoExameNaoEncontrado="encerrarAtendimentoExameNaoEncontrado"
          :class="isAtendimentoComp ? 'animated fadeIn' : 'animated fadeOut'" />
      </v-card>
    </v-fade-transition>
  </v-col>
  <v-col cols="9" md="9" sm="9" v-show="medico != null">
    <fila-medica :medico="medico" @voltar="medico = null" />
  </v-col>

  <v-col cols="9" md="9" sm="9" class="mr-0 pr-0" v-if="!isAtendimentoComp && medico == null"
    :class="!isAtendimentoComp ? 'animated fadeIn' : 'animated fadeOut'">
    <!-- Stepper visível diretamente (sem dialog) -->
    <v-stepper v-if="stepers_Local_Guiche_Servicos && !infoPacienteDialog && !infoSenhasDialog && !dialogHelp"
      v-model="e1" outlined class="mb-4 mr-2 rounded-lg">
      <!-- Cabeçalho do Stepper - Estilizado -->
      <v-stepper-header class="elevation-1">
        <v-stepper-step step="1" :complete="e1 > 1" editable color="primary" class="font-weight-bold">
          <template v-slot:label>
            <span class="d-block primary--text text--darken-2">Passo 1</span>
            <span class="d-block subtitle-1">Selecionar Local</span>
          </template>
        </v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step step="2" :complete="e1 > 2" editable color="primary" class="font-weight-bold">
          <template v-slot:label>
            <span class="d-block primary--text text--darken-2">Passo 2</span>
            <span class="d-block subtitle-1">Selecionar Guichê</span>
          </template>
        </v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step step="3" editable color="primary" class="font-weight-bold">
          <template v-slot:label>
            <span class="d-block primary--text text--darken-2">Passo 3</span>
            <span class="d-block subtitle-1">Serviços</span>
          </template>
        </v-stepper-step>
      </v-stepper-header>

      <!-- Conteúdo do Passo 1 - Seleção de Local -->
      <v-stepper-content step="1">
        <v-card flat class="rounded-lg" style="min-height: 300px;" height="600px">
          <v-card-title class="justify-center pb-4">
            <v-icon large color="primary" class="mr-2">mdi-map-marker</v-icon>
            <span class="headline">Selecione o Local de Atendimento</span>
          </v-card-title>
          <v-sheet elevation="0" rounded="xl">
            <v-divider />
            <v-list-item-group
              v-model="selectedUnidade"
              color="primary"
            >
              <v-list-item
                v-for="(unidade, i) in unidades"
                :key="i"
                @click="selecionarUnidade(unidade)"
              >
                <v-list-item-icon>
                  <v-icon>add_location</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title v-text="unidade.nomeUnidade"></v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
            <div class="pa-4">
              <v-chip-group v-model="idLocalEscolhido" active-class="primary white--text" column mandatory>
                <v-chip v-for="item in listaLocais" :key="item.idLocal" :value="item.idLocal" filter class="ma-1"
                  large :color="idLocalEscolhido === item.idLocal ? 'primary' : 'grey lighten-3'">
                  <v-icon left v-if="idLocalEscolhido === item.idLocal">mdi-check-circle</v-icon>
                  <span class="subtitle-1 font-weight-medium">{{ item.nomeLocal }}</span>
                </v-chip>
              </v-chip-group>
            </div>
          </v-sheet>
        </v-card>
        <v-divider />

        <v-card-actions class="px-0 pt-4">
          <v-spacer></v-spacer>
          <v-btn large rounded color="primary" class="px-6" @click="e1 = 2" :disabled="!idLocalEscolhido">
            Próximo
            <v-icon right>mdi-arrow-right</v-icon>
          </v-btn>
        </v-card-actions>
      </v-stepper-content>

      <!-- Conteúdo do Passo 2 - Seleção de Guichê -->
      <v-stepper-content step="2">
        <v-card  flat class="pa-4 rounded-lg" height="600px">
          <v-card-title class="justify-center pb-4">
            <v-icon large color="primary" class="mr-2">mdi-desk</v-icon>
            <span class="headline">Selecione Seu Guichê</span>
          </v-card-title>

          <v-select v-model="guicheSelecionado" :items="guiches" label="Guichê" outlined color="primary"
            prepend-icon="mdi-numeric" class="mt-8" :menu-props="{ offsetY: true }"></v-select>

          <v-alert v-if="guicheSelecionado === '?'" type="warning" border="left" class="mt-4">
            Por favor, selecione um guichê válido para continuar
          </v-alert>
        </v-card>
        <v-divider />
        <v-card-actions class="px-0 pt-4">
          <v-btn text large color="grey darken-1" @click="e1 = 1">
            <v-icon left>mdi-arrow-left</v-icon>
            Voltar
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn large rounded color="primary" class="px-6" @click="e1 = 3" :disabled="guicheSelecionado === '?'">
            Próximo
            <v-icon right>mdi-arrow-right</v-icon>
          </v-btn>
        </v-card-actions>
      </v-stepper-content>

      <!-- Conteúdo do Passo 3 - Seleção de Serviços -->
      <v-stepper-content step="3">
        <v-card flat class="rounded-lg" height="600px" style="min-height: 300px; max-height: 600px; overflow-y: auto;" >
          <v-card-title class="justify-center pt-4">
            <v-icon large color="primary" class="mr-2">mdi-clipboard-list</v-icon>
            <span class="headline">Selecione os Serviços</span>
          </v-card-title>

          <v-card-text class="px-4">
            <v-subheader class="pl-0">
              <v-checkbox v-model="todosServicosSelecionados" label="Selecionar Todos" color="primary"
                hide-details @click="selecionarTodosCheckList"></v-checkbox>
            </v-subheader>

            <v-divider class="mb-4"></v-divider>

            <v-list  class="pt-0" dense>
              <template v-for="(item, index) in listaServicosRecepcionista">
                <v-list-item :key="item.idEspecialidade" class="px-0">
                  <v-list-item-action class="my-0 mr-2">
                    <v-checkbox v-model="item.status" color="primary" hide-details></v-checkbox>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title class="subtitle-1">
                      {{ item.nomeEspecialidade }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-divider v-if="index < listaServicosRecepcionista.length - 1" :key="index"></v-divider>
              </template>
            </v-list>
          </v-card-text>
        </v-card>
        <v-divider class="mt-2" />
        <v-card-actions class="px-0 pt-4">
          <v-btn text large color="grey darken-1" @click="e1 = 2">
            <v-icon left>mdi-arrow-left</v-icon>
            Voltar
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn large rounded color="primary" class="px-6"
            @click="stepers_Local_Guiche_Servicos = false, setarGuiche(), adicionarServicosRecepcionista(), e1 = 1">
            <v-icon left>mdi-check</v-icon>
            Confirmar
          </v-btn>
        </v-card-actions>
      </v-stepper-content>
    </v-stepper>
    <v-card outlined class="mr-8" v-if="!stepers_Local_Guiche_Servicos && !infoPacienteDialog && !infoSenhasDialog && !dialogHelp">
      <v-alert class="ma-2" v-model="alert" border="left" close-text="Close Alert" color="blue" dark dismissible>
        Seja bem vindo(a),
        <b>{{ nomeFormatado(user.nome) }}!</b>
        <br>Inicialmente, certifique-se do
        <b>local de atendimento</b>. Logo após, escolha o seu
        <b>guichê</b>. Então, clique e chame os itens das listas.
      </v-alert>
      <v-row class="mb-2" no-gutters>
        <!-- Fila Regular - Verde (#01579B) -->
        <v-col class="pr-1" :cols="col1">
          <v-card v-show="!exibirServicosEspeciais" class="pa-2 rounded-lg" flat tile height="800px">
            <div class="text-center text-h6 pb-2" style="color: #757575">
              <v-icon left style="color: #01579B">mdi-account-group</v-icon>
              FILA REGULAR
            </div>
            <v-divider class="mb-2" style="background-color: #01579B; opacity: 0.3" />

            <codigo-ficha
              v-if="listaSemPrioridade.length > 0"
              :btn-op="!fezChamada && !isPendente"
              :is-disabled="desabilitaLista()"
              :my-atendimento="atendimento"
              :em-chamada="guiche == 0 || !atendimento.codigo.length || iniciouAtendimento || desabilitaBotaoChamar"
              :class="!desabilitaLista() ? 'pulse' : ''"
              :isOpen="true"
              :propriedade="listaSemPrioridade[0].codigoSigla"
              :codigo="listaSemPrioridade[0].codigo"
              :data-chegada="converterDate(listaSemPrioridade[0].dataChegada)"
              :servicos="atendimento.servicos"
              :tipo="1"
              :color-text="!desabilitaLista() ? 'white' : 'grey--text text--darken-1'"
              :color="!desabilitaLista() ? 'light-blue' : 'grey lighten-3'"
              @my-col="setColunas"
              @chamar="fazerChamada"
              @iniciarAtendimento="iniciarAtendimento"
              @naoCompareceu="chamadaNaoAtendida"
              @add-atendimento="addAtendimento(listaSemPrioridade[0], 1)"
            />

            <v-virtual-scroll :bench="0" class="mt-2" :items="listaSemPrioridadeAux" height="650" item-height="60">
              <template v-slot:default="{ item }">
                <v-card flat class="rounded-lg mb-1" style="background-color: #FAFAFA">
                  <v-row no-gutters align="center">
                    <v-col cols="7" class="pa-2 text-center">
                      <strong class="display-1" style="color: #757575">
                        {{ item.codigoSigla }}{{ item.codigo }}
                      </strong>
                    </v-col>
                    <v-col cols="1">
                      <v-divider vertical style="opacity: 0.3" />
                    </v-col>
                    <v-col cols="4" class="text-center">
                      <v-chip small outlined style="background-color: #757575" class="ma-1">
                        <v-icon left small style="color: #757575">mdi-clock-outline</v-icon>
                        <span class="caption" style="color: #757575">{{ converterDate(item.dataChegada) }}</span>
                      </v-chip>
                    </v-col>
                  </v-row>
                </v-card>
              </template>
            </v-virtual-scroll>
          </v-card>
        </v-col>

        <v-divider vertical class="mr-1" />

        <!-- Fila Prioritária - Laranja (#D45C00) -->
        <v-col class="pr-1" :cols="col2">
          <v-card v-show="!exibirServicosEspeciais" class="pa-2 rounded-lg" tile height="800px" flat>
            <div class="text-center text-h6 pb-2" style="color: gray">
              <v-icon left style="color: #FF5722">mdi-account-heart</v-icon>
              FILA PRIORITÁRIA
            </div>
            <v-divider class="mb-2" style="background-color: #D45C00; opacity: 0.3" />

            <codigo-ficha
              v-if="listaPrioridade.length > 0"
              :btn-op="!fezChamada && !isPendente"
              :is-disabled="!desabilitaLista()"
              :my-atendimento="atendimento"
              :em-chamada="guiche == 0 || !atendimento.codigo.length || iniciouAtendimento || desabilitaBotaoChamar"
              :class="desabilitaLista() ? 'pulse' : ''"
              :isOpen="true"
              :propriedade="listaPrioridade[0].codigoSigla"
              :codigo="listaPrioridade[0].codigo"
              :data-chegada="converterDate(listaPrioridade[0].dataChegada)"
              :servicos="atendimento.servicos"
              :tipo="1"
              :color-text="desabilitaLista() ? 'white' : 'grey--text text--darken-1'"
              :color="desabilitaLista() ? 'deep-orange' : 'grey lighten-3'"
              :disabled-color="'grey lighten-2'"
              :disabled-text-color="'grey--text text--darken-1'"
              @my-col="setColunas"
              @chamar="fazerChamada"
              @iniciarAtendimento="iniciarAtendimento"
              @naoCompareceu="chamadaNaoAtendida"
              @add-atendimento="addAtendimento(listaPrioridade[0], 1)"
            />

            <v-virtual-scroll :bench="0" class="mt-2" :items="listaPrioridadeAux" height="650" item-height="60">
              <template v-slot:default="{ item }">
                <v-card flat class="rounded-lg mb-1" style="background-color: #FAFAFA">
                  <v-row no-gutters align="center">
                    <v-col cols="7" class="pa-2 text-center">
                      <strong class="display-1" style="color: #757575">
                        {{ item.codigoSigla }}{{ item.codigo }}
                      </strong>
                    </v-col>
                    <v-col cols="1">
                      <v-divider vertical style="opacity: 0.3" />
                    </v-col>
                    <v-col cols="4" class="text-center">
                      <v-chip small style="background-color: #f9e0d1" outlined class="ma-1">
                        <v-icon left small style="color: #757575">mdi-clock-outline</v-icon>
                        <span class="caption" style="color: #757575">{{ converterDate(item.dataChegada) }}</span>
                      </v-chip>
                    </v-col>
                  </v-row>
                </v-card>
              </template>
            </v-virtual-scroll>
          </v-card>
        </v-col>

        <v-divider vertical class="mr-1" />

        <!-- Coluna Direita -->
        <v-col :cols="col3">
          <v-row no-gutters>
            <!-- Não Compareceu - Roxo (#9900D4) -->
            <v-col cols="12">
              <v-card class="pa-2 rounded-t-lg" tile height="400px" flat>
                <div class="text-center pb-3" style="color: gray">
                  <v-icon left style="color: #9900D4">mdi-account-cancel</v-icon>
                  FALTOU
                </div>
                <v-divider style="background-color: #9900D4; opacity: 0.3" />

                <v-virtual-scroll v-if="guiche !== '?'" :bench="0" class="mt-2" :items="listaNaoCompareceu" height="340" item-height="60">
                  <template v-slot:default="{ item }">
                    <codigo-ficha :btn-op="!fezChamada && !isPendente" :is-disabled="false"
                      :my-atendimento="atendimento"
                      :em-chamada="guiche == 0 || !atendimento.codigo.length || iniciouAtendimento || desabilitaBotaoChamar"
                      :propriedade="item.codigoSigla" :codigo="item.codigo"
                      :data-chegada="converterDate(item.dataChegada)" :servicos="atendimento.servicos" :tipo="1"
                      :color-text="'white'" :color="'#616161'" @my-col="setColunas" @chamar="fazerChamada"
                      @iniciarAtendimento="iniciarAtendimento" @naoCompareceu="chamadaNaoAtendida"
                      @add-atendimento="addAtendimento(item, 2)" />
                  </template>
                </v-virtual-scroll>
              </v-card>
            </v-col>

            <!-- Pendentes - Azul (#2A757F) -->
            <v-col cols="12">
              <v-card class="pa-2 rounded-b-lg" tile height="400px" flat>
                <div class="text-center pb-2" style="color: grey">
                  <v-icon left style="color: #2A757F">mdi-account-clock</v-icon>
                  PENDENTE
                </div>
                <v-divider style="background-color: #2A757F; opacity: 0.3" />

                <v-virtual-scroll v-if="guiche !== '?'" :bench="0" class="mt-2" :items="listaPendentes" height="350" item-height="60">
                  <template v-slot:default="{ item }">
                    <codigo-ficha :btn-op="false" :is-disabled="false" :my-atendimento="atendimento"
                      :em-chamada="guiche == 0 || !atendimento.codigo.length || iniciouAtendimento || desabilitaBotaoChamar"
                      :propriedade="item.codigoSigla" :codigo="item.codigo"
                      :data-chegada="converterDate(item.dataChegada)" :servicos="atendimento.servicos" :tipo="1"
                      :color-text="'white'" :color="'#616161'" @my-col="setColunas" @chamar="fazerChamada"
                      @iniciarAtendimento="iniciarAtendimento" @naoCompareceu="chamadaNaoAtendida"
                      @add-atendimento="addAtendimento(item, 3)" />
                  </template>
                </v-virtual-scroll>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <div v-if="infoPacienteDialog" fullscreen hide-overlay transition="dialog-bottom-transition">
        <v-card>
          <infoPaciente class="pt-2" :tipo="2" @fechar="setDialog(1)" />
          <v-card-actions>
            <v-spacer />
            <v-btn color="blue darken-3" text @click="infoPacienteDialog = false">
              fechar
            </v-btn>
          </v-card-actions>
        </v-card>
      </div>
      <div v-if="infoSenhasDialog" fullscreen hide-overlay transition="dialog-bottom-transition">
        <v-card>
          <infoSenhas v-if="infoSenhasDialog" class="pt-2" :tipo="2" @fechar="setDialog(2)" />
          <v-card-actions>
            <v-spacer />
            <v-btn color="blue darken-3" text @click="infoSenhasDialog = false">
              fechar
            </v-btn>
          </v-card-actions>
        </v-card>
      </div>
      <div v-if="dialogHelp">
        <HelperRecepcionista :lista-help="listaHelp" :dialog-help="dialogHelp" :descricao-dialogo="''"
          @alterar-dialog-help="alterarDialogHelp" />
      </div>
    </v-card>
  </v-col>
</v-row>
<v-row justify="center">
  <v-dialog v-model="dialogServicosAtendente" persistent scrollable max-width="350px">
    <v-card>
      <v-toolbar color="primary" dark>
        <v-toolbar-title>Meus Serviços</v-toolbar-title>
        <v-spacer />

        <v-btn icon @click="dialogServicosAtendente = false">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-divider />

      <v-card-text style="height: 270px;">
        <v-list subheader one-line>
          <v-subheader hover>
            <a @click="selecionarTodosCheckList">{{ textoSelecionarTodos }}</a>
          </v-subheader>
          <template v-for="(item, index) in listaServicosRecepcionista">
            <v-list-item :key="item.title" ripple>
              <v-checkbox v-model="item.status" :label="`${item.nomeEspecialidade}`" />
            </v-list-item>
            <v-divider v-if="index + 1 < listaServicosRecepcionista.length" :key="index" />
          </template>
        </v-list>
      </v-card-text>
      <v-card-actions class="pr-4">
        <v-spacer />
        <v-btn rounded color="primary" dark @click="adicionarServicosRecepcionista()">
          Salvar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</v-row>
<v-row justify="center">
  <v-dialog persistent v-model="aguardandoConexao" width="300">
    <v-card color="primary" dark>
      <v-card-text>
        Aguardando conexão...
        <v-progress-linear indeterminate color="white" class="mb-0" />
      </v-card-text>
    </v-card>
  </v-dialog>
</v-row>

        <v-dialog persistent v-model="dialogTransferirAtendimento" scrollable max-width="350px">
          <v-card>
            <v-toolbar color="primary" dark>
              <v-toolbar-title>Transferir Atendimento</v-toolbar-title>
              <v-spacer></v-spacer>

              <v-btn icon>
                <v-icon @click="dialogTransferirAtendimento = false">close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-divider></v-divider>

            <v-card-text style="height: 270px;">
              <v-subheader v-if="listaTransferirAtendimentosMedicos.length == 0">Não há atendimento para transferir este
                Paciente</v-subheader>
              <v-radio-group v-model="radioGroup">
                <v-radio v-for="(item, index) in listaTransferirAtendimentosMedicos" :key="index"
                  :label="` ${item.nomeEspecialidade}`" :value="index"></v-radio>
              </v-radio-group>
            </v-card-text>
            <v-card-actions class="pr-4">
              <v-spacer></v-spacer>
              <v-btn :disabled="listaTransferirAtendimentosMedicos.length == 0" @click="transferirAtendimento" round
                color="primary">Transferir</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialogChamadaJaFeita" width="500">
          <v-card>
            <v-card-title dark class="white--text headline red lighten-2" primary-title>
              Ficha de atendimento já chamada
            </v-card-title>

            <v-card-text>
              Essa Ficha já foi chamada por um outro Guichê. Escolha uma outra ficha e chame-a imediatamente.
              <br>
              <strong class="red--text text--lighten-1">*** Caso esteja chamando um Item da ficha de pendentes,
                verifique se foi utilizado o mesmo número de guichê ao chamar tal ficha.</strong>
            </v-card-text>

            <v-divider />

            <v-card-actions>
              <v-spacer />
              <v-btn color="primary" text @click="chamadaJaFeita">
                Ok
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="infoPacienteDialog" fullscreen hide-overlay transition="dialog-bottom-transition">
          <v-card>
            <infoPaciente class="pt-2" :tipo="2" @fechar="setDialog(1)" />
            <v-card-actions>
              <v-spacer />
              <v-btn color="blue darken-3" text @click="infoPacienteDialog = false">
                fechar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="infoSenhasDialog" fullscreen hide-overlay transition="dialog-bottom-transition">
          <v-card>
            <infoSenhas v-if="infoSenhasDialog" class="pt-2" :tipo="2" @fechar="setDialog(2)" />
            <v-card-actions>
              <v-spacer />
              <v-btn color="blue darken-3" text @click="infoSenhasDialog = false">
                fechar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

  </v-container>

</template>

<script>
// eslint-disable-next-line
/* eslint-disable */
import Cookies from "js-cookie";
import _ from "lodash";
import HelperRecepcionista from "./../components/helper/Helper";
import { mask } from "vue-the-mask";
import { getToken, setToken } from "../store/auth";
import socketService from "../services/socket.service";
import recepcionistaService from "../services/recepcionista.service";
import draggable from "vuedraggable";
import infoPaciente from "../components/paciente/pacienteInfoOs"
import infoSenhas from "../components/paciente/infoSenhas.vue"
import senha from "../components/recepcionista/senha.vue"
import atendimento from '../components/recepcionista/atendimento.vue'
import toolbar from "../components/toolbar"
import EventBus from '../main'
import filaMedica from "../components/recepcionista/filaMedica"
import listaMedicos from "../components/recepcionista/listaDeMedicos.vue"
import user from "../store/modules/usermodule";


export default {
  name: "homeRecepcionista",
  directives: {
    mask
  },

  components: {
    infoPaciente,
    infoSenhas,
    draggable,
    toolbar,
    filaMedica,
    listaMedicos,
    HelperRecepcionista,
    'codigo-ficha': senha,
    atendimento,
    EventBus

  },

  data() {
    return {
      e1: 1,
      medico: null,
      steps: 3,
      scroll: true,
      isAtendimentoComp: false,
      codigoColor: {},
      isNumero: true,
      dialogHelp: false,
      dialogCodigo: 1,
      servicosOsLoading: false,
      servicosOsOk: false,
      servicosOsErro: { isErro: false, tipo: " " },
      alertPreferenciaObrigatoria: false,
      listaHelp: [],
      listaSemPrioridadeAux: [],
      listaPrioridadeAux: [],
      unidade: [],
      unidades: [],
      valid: true,
      infoPacienteDialog: false,
      infoSenhasDialog: false,
      voltouOrdenarExames: false,
      blockCallMethods: false,
      mensagemAutomatico: "",
      blockMethod: false,
      isCancelarAtendimento: false,
      chamouListaHelp: false,
      erroNumero: "",
      socket: "",
      col1: '',
      col2: '',
      col3: 2,
      step: 0,
      listaEsperaCancelar: [
        { text: "Cancelar Atendimento", numero: "1" },
        { text: "Adicionar em Espera", numero: "2" }
      ],
      elementoListaEsperaCancelar: "1",
      unidadePreferencia: "",
      textoSelecionarTodos: "Selecionar todos",
      selecionouTodos: false,
      exibirTabela: false,
      mask: "###########",
      exibirServicosEspeciais: false,
      quantAtendimentos: 0,
      idOrdemServico: "",
      variavelPrioridade: 0,
      variavelPrioridadeEspecial: 0,
      DescriçãoLocal: "",
      listaLocais: [],
      numeroPaciente: "",
      selecionarTodos: false,
      // rules: [
      //   v =>
      //     (this.numeroPaciente.length > 0 && this.numeroPaciente.length < 11)
      //      || "O número deve possuir 11 dígitos",
      //    v => this.verificaNumeroTelefone() || 
      //     "O número deve possuir 11 dígitos ou pode ser vazio"
      // ],
      rules2: [
        v => v.length <= 11 || "O número deve ser vazio ou ter 11 digitos"
      ],
      dialogCancelarAtendimento: false,
      dialogCancelarEsperaAtendimento: false,
      dialogMudarLocal: false,
      dialogServicos: false,
      isAtendimento: false,
      intervalos: [],
      consultas: [],
      dataNascimentoPaciente: "",
      dialogChamadaJaFeita: false,
      dialogCronometroAtendimento: false,
      nomeEspecialidade: "",
      mensagemProximaUnidade: "",
      mensagemIdProximaUnidade: null,
      mensagemProximoLocal: "",
      mensagemProximoLocalMontada: "",
      mensagemProximoLocalDialog: "",
      idExame: "",
      desabilitaBotaoChamar: false,
      idServicoRetornadoDaOs: "",
      idLocalRetornadoDaOs: "",
      tempoAtendimento: "00 : 00",
      quantVerificarTempoAtendimento: 0,
      seconds: 0 * 60,
      stepers_Local_Guiche_Servicos: false,
      dialogErroMudarLocal: false,
      dialogProximoAtendimento: false,
      dialogCadastrarPreferencia: false,
      dialogOs: false,
      dialogPrimeiroAcesso: false,
      dialogServicosAtendente: false,
      dialogTransferirAtendimento: false,
      dialogOrdenarExames: false,
      dialogAvisoAtendimento: false,
      dialogProximasUnidades: false,
      radioGroup: 0,
      guiches: [1, 2, 3, 4, 5, 6, 7, "Autorização"],
      alert: true,
      selected: [2],
      TextoModalHeadline: {
        texto: "Código O.S",
        class: "dark-blue lighten-4"
      },
      codigoOS: "",
      fezChamada: false,
      isPendente: false,
      aguardandoConexao: false,
      entrouEmAguardandoConexao: false,
      testedialogo: true,
      idMedicoPreferencia: "",
      idMedico: null,
      nomeExame: "",
      nomePaciente: "",
      idPaciente: "",
      idExamesos: "",
      idServicoTransferir: "",
      localEscolhido: "",
      selectedUnidade: null,
      todosServicosSelecionados: false,
      idUnidadeSelecionada: null,
      idLocalEscolhido: "",
      idUnidadeServico: "",
      idLocalMedico: "",
      servicoMenorFila: "",
      nomeLocal: "",
      medicos: [],
      servicos: [],
      iniciouAtendimento: false,
      mensagemNotificacaoSocket: "default",
      guicheSelecionado: "?",
      segundos: 0 + "0",
      minuto: 0 + "0",
      hora: 0 + "0",
      guiche: 0,
      dialogGuiche: false,
      listaAtendimentos: [],

      tamListaAtendimentos: 0,
      tamListaSemPrioridade: 0,

      listaPrioridade: [],
      listaSemPrioridade: [],
      listaServicosPrioridade: [],
      listaEspecialComPrioridade: [],
      listaEspecialSemPrioridade: [],
      listaPendentes: [],
      listaNaoCompareceu: [],

      listaServicosRecepcionista: [],
      listaTransferirAtendimentosMedicos: [],

      listaTabelaServicos: [],
      itensTabelaConsultas: [],
      listaQuantConsultas: [],

      listaServicosAgrupados: [],
      listaExamesNaoEncontrados: [],
      listaMedicosAgrupados: [],
      desabilitaBotaoAdicionar: true,

      servicosAddOrdemServico: [],
      exibiuDialogProximasUnidades: false,
      mensagemDialogPrimeiraUnidade: "",
      mensagemDialogSegundaUnidade: "",
      mensagemDialogTerceiraUnidade: "",
      anoNascimento: null,
      mAnoNascimento: null,
      dados: "",
      items: [
        {
          title: 'Pacientes',
          id: 1,
          icon: 'person_search'
        },
        {
          title: 'Senhas',
          id: 2,
          icon: 'search'
        }
      ],
      atendimento: {
        codigo: "",
        codigoSigla: '',
        servico: "",
        prioridade: "",
        idAtendimento: "",
        idServico: "",
        dataChegada: "",
        status: "",
        prioridadeServico: "",
        nomeEspecialidade: "",
        dataStatus: "",
        servicos: []
      },
      desserts: [
        {
          nomeEspecialidade: "",
          count: 0
        }
      ],
      headers: [
        {
          text: "Serviço",
          align: "center",
          sortable: true,
          value: "nomeEspecialidade"
        },
        { text: "Quantidade", value: "count", sortable: true, align: "center" }
      ],
      mLocais: []
    };
  },
  props: {
    source: String
  },

  watch: {
    selectedUnidade: function (val) {
      if (val != null && this.unidades[val]) {
        this.idUnidadeSelecionada = this.unidades[val].idUnidade
        this.retornarLocais(this.idUnidadeSelecionada)
      }
    },
    step: function () {
      this.atualizarEstadoBotaoAdicionar()
    },
    numeroPaciente: function (val) {
      this.validarNumeroTelefone(val)
      this.atualizarEstadoBotaoAdicionar()
    },
    isNumero: function () {
      this.atualizarEstadoBotaoAdicionar()
    },
    listaSemPrioridade: function (val) {
      this.listaSemPrioridadeAux = []
      for (let i = 1; i < this.listaSemPrioridade.length; i++) {
        this.listaSemPrioridadeAux.push(this.listaSemPrioridade[i])
      }
    },
    listaPrioridade: function (val) {
      this.listaPrioridadeAux = []
      for (let i = 1; i < this.listaPrioridade.length; i++) {
        this.listaPrioridadeAux.push(this.listaPrioridade[i])
      }
    },

    idLocalEscolhido: function (val) {
      this.alterarLocal();
    },



    // isNumero: function (val) {
    //   if (!val) {
    //     this.numeroPaciente = ""
    //     this.erroNumero = ""
    //   }
    //   if (this.erroNumero.length > 0 && !this.isNumero) {
    //      this.erroNumero = ""
    //   } 
    // }
  },
  beforeDestroy: function () {
    console.log("em beforeDestroy...");
    this.limparIntervalos();
    this.socket.close();
  },
  created() {

    this.user = this.$store.getters.usuario
    this.nomeLocal = this.user.nomeLocal
    // this.retornarLocais()
  },

  methods: {
    selecionarUnidade (index) {
      this.retornarLocais(this.unidades[index])
    },
    selecionarMedico(data) {
      this.medico = data
    },
    parseCsv(value) {
      if (value == null || value === "") {
        return []
      }

      return String(value)
        .split(",")
        .map(item => item.trim())
        .filter(Boolean)
    },
    retornarNomesLocaisPorIds(ids) {
      return ids
        .map(idLocal => {
          const local = this.mLocais.find(item => String(item.idLocal) === String(idLocal))
          return local ? local.nomeLocal : ""
        })
        .filter(Boolean)
    },
    atualizarEstadoBotaoAdicionar() {
      const totalServicos = this.listaServicosAgrupados.length
      const estaNoUltimoPasso = totalServicos > 0 && this.step >= totalServicos - 1
      const telefoneValido = !this.isNumero || this.erroNumero.length === 0

      this.desabilitaBotaoAdicionar = !(estaNoUltimoPasso && telefoneValido)
    },
    verificarBotaoAdicionar(data) {
      this.listaServicosAgrupados = data
      this.atualizarEstadoBotaoAdicionar()
    },
    mudarDialogCancelarEsperaAtendimento(elemento) {
      console.log('Elemento ' + elemento)
      this.dialogCancelarEsperaAtendimento = false
    },
    parceInt(val) {
      console.log(val);
      if (Number.isInteger(val)) {
        return `${val}`
      } else {
        return val
      }
    },
    refactorList(list) {
      let mList = list
      if (mList.length > 0) {
        mList.splice(0, 1)
      }
      return mList
    },
    chamadaJaFeita() {
      this.dialogChamadaJaFeita = false
      this.atendimento = {
        codigo: "",
        codigoSigla: '',
        servico: "",
        prioridade: "",
        idAtendimento: "",
        idServico: "",
        dataChegada: "",
        status: "",
        prioridadeServico: "",
        nomeEspecialidade: "",
        dataStatus: "",
        servicos: []
      }
    },
    setColunas(data) {
      this.codigoColor = {
        cardColor: '',
        textColor: ''
      }
      this.codigoColor.cardColor = 'quadradoB'
      this.codigoColor.textColor = 'white--text'
      this.codigoColor.isDark = true
    },
    setDialog(data) {
      switch (data) {
        case 1:
          this.infoPacienteDialog = !this.infoPacienteDialog
          break;
        case 2:
          this.infoSenhasDialog = !this.infoSenhasDialog
          break;
        default:
          break;
      }
    },
    somarStep() {
      this.step++;
      /*
      if (
        this.listaServicosAgrupados[this.step].medicoExigidoRecep &&
        this.listaServicosAgrupados[this.step].medicoPreferencia.idMedico
      ) {
        this.step++;
      } else if (!this.listaServicosAgrupados[this.step].medicoExigidoRecep) {
        this.step++;
      } else if (
        this.listaServicosAgrupados[this.step].medicoExigidoRecep &&
        !this.listaServicosAgrupados[this.step].medicoPreferencia.idMedico
      ) {
        var medicoDefault = { nome: "", idMedico: "" };
        this.listaServicosAgrupados[
          this.step
        ].medicoPreferencia = medicoDefault;
      }*/
    },
    decrementarStep() {
      this.step--
    },

    alterarDialogHelp() {
      this.dialogHelp = false;
    },

    retornarHelp() {
      if (!this.blockMethod) {
        this.blockMethod = true;
        if (this.chamouListaHelp) {
          this.dialogHelp = true;
          this.blockMethod = false;
          return;
        }

        recepcionistaService.recepcionista
          .retornarHelp(this.user.tipo)
          .then(rsp => {
            console.log("rsp retornarHelp:", rsp);
            if (rsp.status == 200) {
              this.chamouListaHelp = true;
              this.listaHelp = this.groupBy(rsp.data, "idTituloHelp");
              this.dialogHelp = true;
            }
            this.blockMethod = false;
          })
          .catch(err => {
            //handle your error here
            this.blockMethod = false;
            console.log(err);
          });
      }
    },

    nomeFormatado(str) {
      var arr = str.split(" ");
      if (arr[1] != null) {
        var preposicao = arr[1].toLowerCase();
        if (
          preposicao == "de" ||
          preposicao == "da" ||
          preposicao == "das" ||
          preposicao == "do" ||
          preposicao == "dos"
        ) {
          preposicao = true;
        } else {
          preposicao = false;
        }
      }
      return arr.slice(0, preposicao ? 3 : 2).join(" ");
    },

    mapearLetraPrioridade(prioridade) {
      if (prioridade === 0) {
        return "C";
      } else if (prioridade === 1) {
        return "P";
      } else if (prioridade === 2) {
        return "B";
      } else if (prioridade === 3) {
        return "A";
      }
    },

    proximoLocalPaciente() {
      // se encontrou nos idLocalMedico do primeiro exame
      if (this.idLocalMedico.indexOf(this.user.idLocal) != -1) {
        this.mensagemProximoLocalDialog = this.user.nomeLocal;
        this.dialogCadastrarPreferencia = false;
        this.dialogProximoAtendimento = true;
      }
      //se n encontrou nos idLocais do primeiro exame
      else {
        // é com esse qu encontrei que faço a verificação no médico.
        var mensagemProximoLocalAux = [];
        var consulta = this.consultas.find(
          consulta => consulta.idExame == this.servicoMenorFila.idExame
        );

        if (!consulta) {
          this.mensagemProximoLocalDialog = this.user.nomeLocal || "";
          this.dialogProximoAtendimento = true;
          return;
        }

        var mensagemAutomatico = this.parseCsv(consulta.automatico).map(x => +x);
        var mensagemProximoLocal = this.parseCsv(consulta.nomeLocal);

        if (!mensagemProximoLocal.length) {
          mensagemProximoLocal = this.retornarNomesLocaisPorIds(this.idLocalMedico);
        }

        mensagemAutomatico.forEach(
          function (element, index) {
            if (!element) {
              mensagemProximoLocalAux.push(mensagemProximoLocal[index]);
            }
          }.bind(this)
        );

        this.mensagemProximoLocalDialog = mensagemProximoLocalAux.join(" ou ");
        this.dialogProximoAtendimento = true;
      }
    },

    verificarAtendimento(atendimento) {
      const atendimentoIdLocal = atendimento.idLocal == null ? null : String(atendimento.idLocal);
      const userIdLocal = this.user.idLocal == null ? null : String(this.user.idLocal);

      // Verificar se o idLocal é nulo ou se é igual ao idLocal do usuário
      if (atendimentoIdLocal !== null && atendimentoIdLocal !== userIdLocal) {
        return false; // Se forem diferentes, retorna false
      }

      if (atendimentoIdLocal !== null && atendimentoIdLocal === userIdLocal) {
        return true
      }

      // Verificar os serviços da recepcionista
      let encontrou = false;
      this.listaServicosRecepcionista.forEach(servico => {
        if (servico.status === true) {
          atendimento.servicos.forEach(element => {
            if (element.idServico === servico.idServico) {
              encontrou = true;
            }
          });
        }
      });

      // Retorna o resultado da verificação dos serviços
      return encontrou;
    },

    selecionarTodosCheckList() {
      if (this.textoSelecionarTodos == "Selecionar todos") {
        this.listaServicosRecepcionista.forEach(element => {
          element.status = true;
        });
        this.textoSelecionarTodos = "Desmarcar todos";
        this.$store.dispatch(
          "TextoSelecionarTodos",
          this.textoSelecionarTodos);
        return;
      }
      if (this.textoSelecionarTodos == "Desmarcar todos") {
        this.listaServicosRecepcionista.forEach(element => {
          element.status = false;
        });
        this.textoSelecionarTodos = "Selecionar todos";
        this.$store.dispatch(
          "TextoSelecionarTodos",
          this.textoSelecionarTodos)
      }
    },

    montarTabelaServico() {
      console.log("iterando...tamanho", this.listaTabelaServicos.length);
      for (var index1 = 0; index1 < this.listaTabelaServicos.length; index1++) {
        this.itensTabelaConsultas[index1] = {
          nomeEspecialidade: this.listaTabelaServicos[index1].nomeEspecialidade,
          count: 0,
          idServico: this.listaTabelaServicos[index1].idServico
        };
        for (
          var index2 = 0;
          index2 < this.listaQuantConsultas.length;
          index2++
        ) {
          if (
            this.listaQuantConsultas[index2].idServico ==
            this.listaTabelaServicos[index1].idServico
          ) {
            this.itensTabelaConsultas[index1].count = this.listaQuantConsultas[
              index2
            ].count;
          }
        }
      }
    },

    addQuantTabelaConsultas(atendimento) {
      console.log("em add quant", atendimento);
      atendimento.servicos.forEach(servicoAtend => {
        this.desserts.forEach((element, index) => {
          if (servicoAtend.idServico == element.idServico) {
            element.count++;
            this.$set(this.desserts, index, element);
          }
        });
      });
    },

    subQuantTabelaConsultas(atendimento) {
      console.log("em sub quant", atendimento);
      atendimento.servicos.forEach(servicoAtend => {
        this.desserts.forEach((element, index) => {
          if (servicoAtend.idServico == element.idServico) {
            if (element.count > 0) {
              element.count--;
            }
            this.$set(this.desserts, index, element);
          }
        });
      });
    },

    transferirAtendimento(item) {
      this.radioGroup = item
      if (!this.blockMethod) {
        this.blockMethod = true;

        recepcionistaService.recepcionista
          .transferirAtendimento(
            this.atendimento.idAtendimento,
            this.listaTransferirAtendimentosMedicos[this.radioGroup].idServico,
            this.atendimento.codigo,
            this.atendimento.prioridade,
            this.listaTransferirAtendimentosMedicos[this.radioGroup]
              .nomeEspecialidade
          )
          .then(rsp => {
            console.log("rsp transferirAtendimento:", rsp);
            if (rsp.data == true) {
              this.dialogTransferirAtendimento = false;
              this.exibiuDialogProximasUnidades = false;
              this.fezChamada = false;
              this.servicosAddOrdemServico = [];
              this.isPendente = false;
              this.iniciouAtendimento = false;
              this.atendimento.codigo = "";
              this.atendimento.prioridade = "";
              this.atendimento.nomeEspecialidade = "";
              this.atendimento.servicos = [];
              this.dialogOs = false;
              this.blockMethod = false;
              this.isAtendimentoComp = false;
            }
          })
          .catch(err => {
            //handle your error here
            this.blockMethod = false;
            console.log(err);
          });
      }
    },

    exibirDialogServicosAtendente() {
      this.listaServicosRecepcionista = JSON.parse(
        JSON.stringify(this.user.servicosRecepcionista)
      );
      if (this.user.textoSelecionarTodos != null && this.user.textoSelecionarTodos != '') {
        this.textoSelecionarTodos = this.user.textoSelecionarTodos
      }
      // console.log(this.user)
      // this.textoSelecionarTodos = this.user.textoSelecionarTodos
      this.dialogServicosAtendente = true;
    },

    adicionarServicosRecepcionista() {
      console.log("aquii");
      this.$store.dispatch(
        "ServicosRecepcionista",
        this.listaServicosRecepcionista
      );
      this.$store.dispatch(
        "TextoSelecionarTodos",
        this.textoSelecionarTodos
      );
      this.retornarAtendimentos();
      this.dialogServicosAtendente = false;
    },

    confirmarCancelarAtendimento() {
      this.dialogCancelarAtendimento = true;
    },

    confirmarCancelarEsperaAtendimento() {
      this.elementoListaEsperaCancelar = "1";
      this.dialogCancelarEsperaAtendimento = true;
    },
    limparIntervalos() {
      this.intervalos.forEach(clearInterval);
    },

    verificaNumeroTelefone() {
      return (
        this.numeroPaciente.length == 0 || this.numeroPaciente.length == 11
      );
    },

    validarNumeroTelefone(numero) {
      // console.log(numero)
      var regex = new RegExp('^((1[1-9])|([2-9][0-9]))((3[0-9]{3}[0-9]{4})|(9[0-9]{3}[0-9]{5}))$');
      console.log(regex.test(numero))
      if (!this.isNumero || !numero) {
        this.erroNumero = ""
      } else if (regex.test(numero)) {
        this.erroNumero = ""
      } else {
        this.erroNumero = "Número invalido"
      }
    },

    esperaAtendimento() {
      this.isCancelarAtendimento = false

      var atendimento = JSON.parse(JSON.stringify(this.atendimento));
      var index = this.listaPendentes.findIndex(
        element => element.codigo > atendimento.codigo
      );
      console.log(index);
      if (index == -1) {
        this.listaPendentes.push(atendimento);
      } else {
        this.listaPendentes.splice(index, 0, atendimento);
      }

      this.fezChamada = false;
      this.isPendente = false;
      this.iniciouAtendimento = false;
      this.dialogCronometroAtendimento = false;
      this.dialogCancelarAtendimento = false;
      this.dialogCancelarEsperaAtendimento = false;
      this.atendimento.codigo = "";
      (this.elementoListaEsperaCancelar = "1"),
        (this.atendimento.servicos = []);
      this.atendimento.prioridade = "";
      this.atendimento.nomeEspecialidade = "";
      this.limparIntervalos();
      this.seconds = 0 * 60;
      this.tempoAtendimento = "00 : 00";

      this.isAtendimentoComp = false
    },

    cancelarAtendimento() {
      recepcionistaService.recepcionista
        .cancelarAtendimento(this.atendimento.idAtendimento)
        .then(rsp => {
          console.log("rsp cancelarAtendimento", rsp);
          if (rsp.status == 200) {
            this.fezChamada = false;
            this.isPendente = false;
            this.iniciouAtendimento = false;
            this.dialogCronometroAtendimento = false;
            this.dialogCancelarAtendimento = false;
            this.dialogCancelarEsperaAtendimento = false;
            this.atendimento.codigo = "";
            (this.elementoListaEsperaCancelar = "1"),
              (this.atendimento.servicos = []);
            this.atendimento.prioridade = "";
            this.atendimento.nomeEspecialidade = "";
            this.limparIntervalos();
            this.seconds = 0 * 60;
            this.tempoAtendimento = "00 : 00";
          }
        })
        .catch(err => {
          // handle your error here
          console.log(err);
        });
      this.isAtendimentoComp = false
    },

    encerrarCronometroAtendimento() {
      this.dialogCronometroAtendimento = false;
      this.limparIntervalos();
      this.abrirDialogoOS();
    },

    verificaVezChamada() {

      if (this.fezChamada) {
        this.dialogErroMudarLocal = true;


        return;
      }
      this.stepers_Local_Guiche_Servicos = true;
      //this.dialogMudarLocal = true;
    },

    refreshToken() {
      console.log("token antes:", getToken());

      recepcionistaService.recepcionista
        .refreshToken(getToken(), this.idUnidadeSelecionada, this.user.idLocal)
        .then(rsp => {
          console.log("rsp refreshToken", rsp);
          if (rsp.status == 200) {
            setToken(rsp.data.token);
            console.log("token dps", getToken());

            this.socket.close();
            this.socket = io.connect(socketService.SOCKET_URL, {
              query: {
                token: getToken()
              }
            });
            this.chamarSocket();
            this.retornarMedicos();
            this.retornarPrioridade()
          }
        })
        .catch(err => {
          // handle your error here
          console.log(err);
        });
    },

    alterarLocal() {
      if (this.idLocalEscolhido != this.user.idLocal) {
        recepcionistaService.recepcionista
          .alterarLocal(Number(this.idLocalEscolhido))
          .then(rsp => {
            console.log(rsp.data);
            if (rsp.data == true) {
              //var medicos = this.servicos.filter(element => element.idUnidade2 == unidadePreferencia.idUnidade );
              var local = this.listaLocais.filter(
                element => element.idLocal == this.idLocalEscolhido
              );
              this.$store.dispatch("Local", local[0].nomeLocal);
              this.nomeLocal = local[0].nomeLocal;
              this.user.idLocal = local[0].idLocal;
              this.fezChamada = false;
              this.isPendente = false;
              // this.user.guiche = undefined;
              this.guiche = !this.user.guiche ? "?" : this.user.guiche;
              this.atendimento.codigo = "";
              this.atendimento.prioridade = "";
              this.atendimento.servicos = [];
              this.atendimento.nomeEspecialidade = "";
              console.log("passouuuuu", this.user.guiche);
              this.$store.dispatch("UpdateUser", this.user);
              this.dialogMudarLocal = false;
              this.user.servicosRecepcionista = false;
              this.user.textoSelecionarTodos = ''
              this.itensTabelaConsultas = [];
              // this.$store.dispatch(
              //      "ServicosRecepcionista", []
              // );
              this.$store.dispatch(
                "TextoSelecionarTodos",
                'Selecionar todos');
              this.retornarServicos();
              //this.retornarPrioridade()
              this.refreshToken();
            } else {
              alert("ocorreu um erro durante a requisição");
            }
          })
          .catch(err => {
            //handle your error here
            console.log(err);
          });
      }
    },

    desabilitaLista() {
      //se igual a zero retorna true
      if (
        this.listaPrioridade.length > 0 &&
        this.listaSemPrioridade.length > 0
      ) {
        //return this.variavelPrioridade == 0; // returna verdadeiro se 0
        if (
          this.listaPrioridade[0].dataChegada <
          this.listaSemPrioridade[0].dataChegada
        ) {
          return true;
        }
        if (this.variavelPrioridade == 0) {
          return true;
        }
      } else if (
        this.listaSemPrioridade.length == 0 &&
        this.variavelPrioridade == 0
      ) {
        // e verificar o primeiro da lista
        return true;
      } else if (
        this.listaSemPrioridade.length == 0 &&
        !this.variavelPrioridade == 0
      ) {
        return true;
      }
    },

    retornarLocais(idUnidade) {
      recepcionistaService.recepcionista
        .retornarLocais(idUnidade)
        .then(rsp => {
          console.log("rsp retornarLocais:", rsp);
          this.listaLocais = rsp.data;
        })
        .catch(err => {
          // handle your error here
          console.log(err);
        });
    },

    toggle() { },

    exibirDialogProximasUnidades() {
      var idUnidadeRecepcionista = this.user.idUnidade;
      var retorno = true;
      if (
        this.servicosAddOrdemServico.length > 1 &&
        !this.exibiuDialogProximasUnidades
      ) {
        for (
          let index = 1;
          index < this.servicosAddOrdemServico.length;
          index++
        ) {
          const element1 = this.servicosAddOrdemServico[index - 1];
          const element2 = this.servicosAddOrdemServico[index];
          const element3 = this.servicosAddOrdemServico[index + 1];
          if (
            element2.idUnidade == idUnidadeRecepcionista &&
            element1.idUnidade != idUnidadeRecepcionista
          ) {
            this.mensagemDialogPrimeiraUnidade = element1.nomeUnidade;
            this.mensagemDialogSegundaUnidade = element2.nomeUnidade;
            this.dialogProximasUnidades = true;
            this.exibiuDialogProximasUnidades = true;
            retorno = false;
            break;
          }
        }
      }
      return retorno;
    },

    organizarServicosEnviados() {
      console.log('numerooo: ', this.numeroPaciente, this.blockMethod)
      if (!this.isNumero) this.numeroPaciente = null

      if (!this.blockMethod) {

        this.blockMethod = true;

        var servicosExigidosRecepcionistaErro = this.listaServicosAgrupados.filter(
          element => {
            return (
              element.medicoExigidoRecep &&
              element.medicoPreferencia.idMedico == ""
            );
          }
        );

        console.log('numerooo: ', this.listaServicosAgrupados.length)
        if (this.listaServicosAgrupados.length == 0) { // mudar para 1

          if (
            this.listaServicosAgrupados[this.step].medicoExigidoRecep &&
            !this.listaServicosAgrupados[this.step].medicoPreferencia.idMedico[0]
          ) {
            var medicoDefault = { nome: "", idMedico: "" };
            this.listaServicosAgrupados[
              this.step
            ].medicoPreferencia = medicoDefault;
            this.blockMethod = false;
            return;
          }
        }

        console.log("filtrados..", servicosExigidosRecepcionistaErro);
        if (servicosExigidosRecepcionistaErro.length) {
          this.alertPreferenciaObrigatoria = true;
          this.blockMethod = false;
          setTimeout(() => {
            this.alertPreferenciaObrigatoria = false;
          }, 5000);
          return;
        }

        // console.log("em organizar...", this.listaServicosAgrupados);
        this.servicosAddOrdemServico = [];
        this.listaServicosAgrupados.forEach(element => {
          var servico = {
            idServico: element.unidadePreferencia.idServico,
            idExame: element[0].idExame,
            filaExame: element.unidadePreferencia.filaExame,
            idMedico: element.medicoPreferencia.idMedico,
            peso: element.unidadePreferencia.peso,
            idLocaisMedico: element.idLocaisMedico,
            idUnidade: element.unidadePreferencia.idUnidade,
            idexamesos: element[0].idexamesos,
            nomeUnidade: element.unidadePreferencia.nomeUnidade,
            idLocalFixo: element.unidadePreferencia.idLocal <= 0 ? null : element.unidadePreferencia.idLocal
          };

          this.servicosAddOrdemServico.push(servico);
        });
        console.log(
          "em organizarServicosEnviados",
          this.servicosAddOrdemServico
        );

        this.servicosAddOrdemServico[0].status = 1;
        this.servicoMenorFila = this.servicosAddOrdemServico[0];

        for (
          let index = 1;
          index < this.servicosAddOrdemServico.length;
          index++
        ) {
          const element = this.servicosAddOrdemServico[index];
          if (
            element.peso >= this.servicosAddOrdemServico[0].peso &&
            element.idUnidade == this.servicosAddOrdemServico[0].idUnidade
          ) {
            element.status = 1;
            if (element.filaExame < this.servicoMenorFila.filaExame) {
              this.servicoMenorFila = element;
            }
          } else {
            element.status = 0;
          }
        }

        if (this.exibirDialogProximasUnidades()) {
          this.adicionarOrdemDeServico(this.servicosAddOrdemServico)
        }


      }

    },
    alteraIsNumero(data) {
      this.isNumero = data
    },
    alteraNumeroPaciente(data) {
      this.numeroPaciente = data
    },
    voltarOrdenarExames() {
      this.dialogOrdenarExames = true;
      this.voltouOrdenarExames = true;
      this.dialogCadastrarPreferencia = false
    },
    agruparConjuntoIdLocaisMedico() {
      var result = [];
      this.servicosAddOrdemServico.forEach(element => {
        if (element.status == 1) {
          result = Array.from(new Set([...result, ...element.idLocaisMedico])); // ?
        }
      });
      this.servicosAddOrdemServico.forEach(element => {
        if (element.status == 1) {
          element.idLocaisMedico = result;
        }
      });
    },

    adicionarOrdemDeServico(servicosAddOrdemServico) {
      // segunda vez
      console.log("addOrdemServico-ServAgrupados", this.listaServicosAgrupados);

      this.agruparConjuntoIdLocaisMedico();
      console.log("servi add Ordem Servico agrupados", servicosAddOrdemServico);

      recepcionistaService.recepcionista
        .adicionarOrdemDeServico(
          this.codigoOS,
          this.atendimento.idAtendimento,
          servicosAddOrdemServico
        )
        .then(rsp => {
          console.log("rsp adicionarOrdemDeServico:", rsp);
          if (rsp.status == 200) {
            const primeiraConsulta = Array.isArray(rsp.data) ? rsp.data[0] : null;
            const idLocaisMedico = primeiraConsulta
              ? this.parseCsv(primeiraConsulta.idLocalMedico).map(x => +x)
              : [];
            const nomesLocais = primeiraConsulta
              ? this.parseCsv(primeiraConsulta.nomeLocal)
              : [];

            this.step = 0;
            this.exibiuDialogProximasUnidades = false;
            this.dialogProximasUnidades = false;
            this.isPendente = false;
            this.desabilitaBotaoAdicionar = true;
            this.consultas = JSON.parse(JSON.stringify(rsp.data));
            this.mensagemProximaUnidade = primeiraConsulta ? primeiraConsulta.nomeUnidade || "" : "";
            this.mensagemIdProximaUnidade = primeiraConsulta ? primeiraConsulta.idUnidadeServico : "";
            console.log('TA MUDANDO ', primeiraConsulta ? primeiraConsulta.idUnidadeServico : "")
            this.idLocalMedico = idLocaisMedico;
            this.mensagemProximoLocal = nomesLocais.length
              ? nomesLocais
              : this.retornarNomesLocaisPorIds(idLocaisMedico);
            this.idExame = primeiraConsulta ? primeiraConsulta.idExame : "";
            this.idMedico = primeiraConsulta ? primeiraConsulta.idMedico : "";
            this.nomeExame = primeiraConsulta ? primeiraConsulta.nomeExame : "";
            this.idUnidadeServico = primeiraConsulta ? primeiraConsulta.idUnidadeServico : "";
            this.nomeEspecialidade = primeiraConsulta ? primeiraConsulta.nomeEspecialidade : "";
            this.idServicoRetornadoDaOs = primeiraConsulta ? primeiraConsulta.idServico : "";
            this.idLocalRetornadoDaOs = primeiraConsulta ? primeiraConsulta.idLocal : "";
            this.idOrdemServico = primeiraConsulta ? primeiraConsulta.idOrdemServico : "";
            this.dialogCadastrarPreferencia = false;
            this.iniciouAtendimento = true;
            this.TextoModalHeadline.texto = "Código O.S";
            this.TextoModalHeadline.class = "blue lighten-3";
            this.codigoOS = "";
            this.dialogOrdenarExames = false;
            this.dialogOs = false;
            this.voltouOrdenarExames = false;
            this.proximoLocalPaciente();
            this.encerrarAtendimento();
            this.blockMethod = false;
          }
        })
        .catch(err => {
          // handle your error here
          this.blockMethod = false;
          console.log(err);
        });
    },

    setarPreferencia(index) {
      console.log("em setar preferencia", index);
      this.servicos[index].idMedico = this.idMedicoPreferencia;
      this.idMedicoPreferencia = "";
    },
    /*
    NÃO PRECISA MAIS, FOI PARA O FILHO (atendimento.vue)
    returnLocal (locais, id) {
     
          mLocais = locais.filter(e => e.idExame == id)
          mLocais.push({
              idLocal: 0, nomeLocal: 'Sem preferência'
            })
           
          return mLocais
    }, */
    setarUnidade(unidadePreferencia, index) {

      console.log("escooo", unidadePreferencia);
      var medicoDefault = { nome: "Sem Médico de Preferência", idMedico: "", idPrestador: "" }
      var medicos = this.servicos.filter(
        element =>
          element.idUnidade2 == unidadePreferencia.idUnidade &&
          element.idExame == this.listaServicosAgrupados[index][0].idExame
      );

      var unidadeSetada = this.servicos.find(
        element => element.idUnidade2 == unidadePreferencia.idUnidade
      );

      this.listaServicosAgrupados[index].medicoPreferencia = "";
      this.listaServicosAgrupados[index].medicoExigidoRecep =
        unidadeSetada.medicoExigidoRecep;
      this.listaServicosAgrupados[index].medicos = medicos;
      this.listaServicosAgrupados[index].idLocaisMedico = [];
      this.listaServicosAgrupados[index].medicos.forEach(element => {
        this.listaServicosAgrupados[index].idLocaisMedico.indexOf(
          element.idLocalMedico
        ) === -1
          ? this.listaServicosAgrupados[index].idLocaisMedico.push(
            element.idLocalMedico
          )
          : "";
      });
      this.listaServicosAgrupados[index].medicos.push(medicoDefault);
      console.log("agrupa apos", this.listaServicosAgrupados);
    },

    // Retorna a lista de serviços por médico
    organizarDadosInterfacePreferencia(listaMedicosOs) {
      this.listaServicosAgrupados = this.groupBy(this.servicos, "idExame");
      console.log("MedicosOS Met Pref", listaMedicosOs);

      this.listaServicosAgrupados.forEach(element => {
        this.$set(element, "fila", [])
        this.$set(element, "unidadePreferencia", ""); // adicionei
        this.$set(element, "medicoPreferencia", "");
        this.$set(element, "medicoExigidoRecep", "");
        console.log('element:: ', element) // Lista de medicos de um serviço/exame
        // console.log('------ ', element[0])
        element.medicoExigidoRecep = element[0].medicoExigidoRecep;
        // verifica se existe medicos com o mesmo id do retorno web
        // console.log(listaMedicosOs);

        var medicoPref = listaMedicosOs.find(
          medico => medico.idExame == element[0].idExame
        );
        console.log("medico prefere", medicoPref);

        if (medicoPref) {
          element.medicoPreferencia = medicoPref
        }
        // verificar medicos com o id dos serviços selecionados pela recepcionista
        if (medicoPref && element.medicoExigidoRecep) {
          for (let elem of medicoPref.idMedico) {
            var medico = this.servicos.find(
              servico => servico.idMedico == elem
            );
            if (medico) {
              console.log("idMedico pref", medico);
              element.medicoPreferencia = {
                nome: medico.nome,
                idMedico: medico.idMedico,
              };

              var unidadePreferencia = {
                nomeUnidade: medico.nomeUnidade,
                idUnidade: medico.idUnidade2,
                filaExame: medico.filaExame,
                peso: medico.peso,
                idServico: medico.idServico2
              };

              element.unidadePreferencia = unidadePreferencia;
              element.fila = this.groupBy(element, "idUnidade2");
              break;
            } else {
              element.medicoPreferencia = { nome: "Sem preferência", idMedico: "" };

              var unidadePreferencia = {
                nomeUnidade: element[0].nomeUnidade,
                idUnidade: element[0].idUnidade2,
                filaExame: element[0].filaExame,
                peso: element[0].peso,
                idServico: element[0].idServico2
              };

              element.unidadePreferencia = unidadePreferencia;
              element.fila = this.groupBy(element, "idUnidade2");
            }
          }
        } else {

          // 
          // console.log(element);
          if (medicoPref) {
            element.medicoPreferencia = { nome: medicoPref.nomeMedico, idMedico: medicoPref.idMedico[0] == 0 ? '' : medicoPref.idMedico[0] }
          } else {
            element.medicoPreferencia = { nome: '', idMedico: '' };
          }


          var unidadePreferencia = {
            nomeUnidade: element[0].nomeUnidade,
            idUnidade: element[0].idUnidade2,
            filaExame: element[0].filaExame,
            peso: element[0].peso,
            idServico: element[0].idServico2
          };

          element.unidadePreferencia = unidadePreferencia;
          element.fila = this.groupBy(element, "idUnidade2");
        }
        // código else aqui
      });
      console.log("apos organizarDadosInterfacePreferencia", this.listaServicosAgrupados.length)
      this.atualizarEstadoBotaoAdicionar()
      this.dialogOrdenarExames = true;
      console.log(
        "apos organizarDadosInterfacePreferencia",
        this.listaServicosAgrupados
      );
    },

    addUnidadesServicos() {
      this.dialogOrdenarExames = false;

      if (this.voltouOrdenarExames) {
        this.dialogCadastrarPreferencia = true;
        return;
      }
      var locaisUnidade = []
      this.servicos.forEach(e => {
        if (!e.automatico) {
          let isLocal = false
          if (locaisUnidade.length > 0) {
            for (let i = 0; i < locaisUnidade.length; i++) {
              const local = locaisUnidade[i];
              if (local.idLocal == e.idLocal && local.idUnidade2 == e.idUnidade2 && local.idExame == e.idExame) {
                isLocal = true
                break
              }
            }
          }
          if (!isLocal) {
            locaisUnidade.push(
              {
                idUnidade2: e.idUnidade2,
                idLocal: e.idLocal,
                nomeLocal: e.nomeLocal,
                idExame: e.idExame
              }
            )
          }
        }

      });
      this.listaServicosAgrupados.forEach((servicoGrupo, index) => {
        this.$set(servicoGrupo, "unidades", []);
        this.$set(servicoGrupo, "medicos", []);
        this.$set(servicoGrupo, "idLocaisMedico", []);
        this.$set(servicoGrupo, "unidadePreferencia", "");
        //this.$set(servicoGrupo, 'medicoPreferencia','')
        var locais = locaisUnidade.filter(e =>
          e.idUnidade2 == servicoGrupo[0].idUnidade2,
        )
        var unidadePreferencia = {
          nomeUnidade: servicoGrupo[0].nomeUnidade,
          idUnidade: servicoGrupo[0].idUnidade2,
          filaExame: servicoGrupo[0].filaExame,
          peso: servicoGrupo[0].peso,
          idServico: servicoGrupo[0].idServico2,
          locais: locais
        };
        servicoGrupo.unidadePreferencia = unidadePreferencia;

        var medicos = this.servicos.filter(
          element =>
            element.idUnidade2 == unidadePreferencia.idUnidade &&
            element.idExame == servicoGrupo[0].idExame
        );

        servicoGrupo.medicos = medicos;
        servicoGrupo.medicos.forEach(element => {
          servicoGrupo.idLocaisMedico.indexOf(element.idLocalMedico) === -1
            ? servicoGrupo.idLocaisMedico.push(element.idLocalMedico)
            : "";
        });

        var medicoDefault = { nome: "Sem Médico de Preferência", idMedico: "", idPrestador: "" };
        servicoGrupo.medicos.push(medicoDefault);
        // aqui add a preferencia...
        this.servicos.forEach(element => {
          // iteracao para saber as unidades de cada exame agrupado

          if (servicoGrupo[0].idExame == element.idExame) {
            var locais = locaisUnidade.filter(e =>
              e.idUnidade2 == element.idUnidade2
            )
            var unidade = {
              nomeUnidade: element.nomeUnidade,
              idUnidade: element.idUnidade2,
              filaExame: element.filaExame,
              peso: element.peso,
              idServico: element.idServico2,
              locais: locais
            };
            if (
              this.listaServicosAgrupados[index].unidades.findIndex(
                element => element.idUnidade2 == unidade.idUnidade
              ) == -1
            ) {
              this.listaServicosAgrupados[index].unidades.push(unidade);
            }
          }
        });
      });
      console.log(
        "listaServicosAgrupados apos addUnidade",
        this.listaServicosAgrupados
      );
      this.dialogCadastrarPreferencia = true;
    },

    addMedicosExame() {
      this.listaServicosAgrupados.forEach((servicoGrupo, index) => {
        this.listaServicosAgrupados[index].medicos = [];
        this.servicos.forEach(element => {
          if (servicoGrupo[0].idExame == element.idExame) {
            var medico = {
              nomeUnidade: servicoGrupo.nomeUnidade,
              idUnidade: servicoGrupo.idUnidade2
            };
            if (
              this.listaServicosAgrupados[index].unidades.findIndex(
                element => element.idUnidade == unidade.idUnidade
              ) == -1
            ) {
              this.listaServicosAgrupados[index].medico.push(unidade);
            }
          }
        });
      });
    },

    novaConsulta() {
      this.step = 0;
      this.dialogCadastrarPreferencia = false;
      this.dialogOs = true;
      this.exibiuDialogProximasUnidades = false;
      this.servicosAddOrdemServico = [];
      this.dialogOrdenarExames = false;
      this.desabilitaBotaoAdicionar = true;
      this.TextoModalHeadline.texto = "Código O.S";
      this.TextoModalHeadline.class = "blue";
      this.codigoOS = "";
      this.nomePaciente = "";
      this.voltouOrdenarExames = false;
      this.servicosOsOk = false;
    },

    // recepcionista chama retornar medicos
    retornarMedicos() {
      recepcionistaService.recepcionista
        .retornarMedicos()
        .then(rsp => {
          // console.log("rsp retornarMedicos:", rsp);
          // this.retornarPrioridade();
          /*this.medicos = rsp.data;
          this.medicos.forEach(medico => {
            if (medico.online == 1) {
              medico.icone = "done";
            } else {
              medico.icone = "clear";
            }
          });*/
        })
        .catch(err => {
          // handle your error here
          console.log(err);
        });
    },

    abrirDialogoOS() {
      this.dialogOs = true;
    },

    retornarMedicosOs() {
      // console.log('Passou ----', this.codigoOS);
      recepcionistaService.recepcionista
        .retornarMedicosOs(this.codigoOS)
        .then(rsp => {
          console.log("retorno retornarMedicosOs");
          var listaMedicosOs = rsp.data;
          listaMedicosOs.forEach(element => {
            if (typeof element.idMedico === 'number') {
              element.idMedico = [element.idMedico]; // Converte em um array
            }
            if (typeof element.idMedico === 'string') {
              element.idMedico = element.idMedico.split(",").map(x => +x);
            }

            // element.idMedico = element.idMedico.split(",").map(x => +x);
          });
          // console.log(listaMedicosOs);

          this.organizarDadosInterfacePreferencia(listaMedicosOs);
          this.dialogOs = false;
        })
        .catch(err => {
          // handle your error here
          console.log(err);
        }).finally(() => {
          this.mAnoNascimento = null
        })
    },
    
    retornarUnidades () {
      recepcionistaService.recepcionista.retornarUnidades().then(r => {
        if (r.status == 200) {
          this.unidades = Array.isArray(r.data) ? r.data : []
        }
      }).catch(err => {
        console.log(err)
        this.unidades = []
      })
    },

    retornarServicosOs(data) {
      this.codigoOS = data.codigoOS
      this.mAnoNascimento = data.mAnoNascimento
      if (!this.codigoOS) {
        console.log("return os length..");
        console.log(this.codigoOS)
        console.log(this.mAnoNascimento)

        return;
      } else {
        this.TextoModalHeadline.texto = "Código O.S";
        this.TextoModalHeadline.class = "blue";
      }

      if (!this.blockMethod) {
        this.blockMethod = true;
        this.servicosOsLoading = true;

        console.log(" em retornar exames os");
        recepcionistaService.recepcionista
          .retornarUsuarioOs(this.codigoOS) //antiga rota : retornarServicosUsuarioOs
          .then(rsp => {
            console.log("rsp de chamar codigo os:", rsp);
            if (rsp.status == 200) {
              recepcionistaService.recepcionista.processarnew(this.codigoOS).then(r => {
                console.log('Processar Resumo Clínico', r.data)
              })
              console.log(rsp)
              if (rsp.data.length != 0) {
                if (rsp.data == 1) {
                  this.servicosOsErro.isErro = true
                  this.servicosOsErro.tipo = "1"
                  this.TextoModalHeadline.texto =
                    "Código não encontrado. Tente novamente";
                  this.TextoModalHeadline.class = "red lighten-2";
                } else if (rsp.data == 2) {
                  this.servicosOsErro.isErro = true
                  this.servicosOsErro.tipo = "2"
                  this.TextoModalHeadline.texto =
                    "O.S cadastrada em outra unidade !";
                  this.TextoModalHeadline.class = "red lighten-2";
                } else if (rsp.data == 3) {
                  this.servicosOsErro.isErro = true
                  this.servicosOsErro.tipo = "3"
                  this.TextoModalHeadline.texto =
                    "O.S cadastrada em outra data !";
                  this.TextoModalHeadline.class = "red lighten-2";
                } else {
                  // console.log('Entrou aqui')
                  this.anoNascimento = null
                  if (rsp.data.anoNascimento) {
                    this.anoNascimento = rsp.data.anoNascimento
                    this.dados = rsp.data

                    this.validarAnoNascimento()
                  } else {
                    // se não tiver data cadastrada no banco

                    this.servicos = this.dados.servicos;
                    this.exibiuDialogProximasUnidades = false;
                    this.numeroPaciente =
                      this.dados.celular == null ? "00000000000" : this.dados.celular;
                    this.nomePaciente = this.dados.nome;
                    this.dataNascimentoPaciente = this.dados.dataNascimento
                    this.listaExamesNaoEncontrados = this.dados.examesNaoEncontrados;
                    this.idPaciente = this.dados.idPaciente;
                    this.idExamesos = this.dados.idExamesos;
                    //this.organizarDadosInterfacePreferencia()
                    this.anoNascimento = null
                    // this.mAnoNascimento = null 
                    this.servicosOsOk = true

                    this.retornarMedicosOs();

                  }

                }

                this.blockMethod = false;
                this.servicosOsLoading = false;
              } else {
                this.blockMethod = false;
                this.servicosOsLoading = false;
                this.servicosOsErro.isErro = true
                this.servicosOsErro.tipo = "6";
                this.TextoModalHeadline.texto =
                  "Não exite exames ABERTOS para essa OS!";
                this.TextoModalHeadline.class = "orange lighten-2";
              }
            } else {
              // console.log('Entrou aqui 2')
              this.blockMethod = false;
              this.servicosOsLoading = false;
              this.servicosOsErro.isErro = true
              this.servicosOsErro.tipo = "4";
              this.TextoModalHeadline.texto =
                "Ocorreu um erro. Tente novamente";
              this.TextoModalHeadline.class = "red lighten-2";
            }
          })
          .catch(err => {
            console.log("error.......");
            this.blockMethod = false;
            this.servicosOsErro.isErro = true
            this.servicosOsErro.tipo = "4";
            this.servicosOsLoading = false;
            this.TextoModalHeadline.texto = "Ocorreu um erro. Tente novamente";
            this.TextoModalHeadline.class = "red lighten-2";
            console.log(err);
          });
      }
    },
    /* MÉTODO ANTIGO (VERSÃO DIALOG)
    retornarServicosOs (data) {     
      this.codigoOS = data.codigoOS
      this.mAnoNascimento = data.mAnoNascimento
      if (!this.codigoOS.length) {
        console.log("return os length..");
        console.log(this.codigoOS)
        console.log(this.mAnoNascimento)
        
        return;
      } else {
        this.TextoModalHeadline.texto = "Código O.S";
        this.TextoModalHeadline.class = "blue";
      }

      if (!this.blockMethod) {
        this.blockMethod = true;
        this.servicosOsLoading = true;

        console.log(" em retornar exames os");
        recepcionistaService.recepcionista
          .retornarUsuarioOs(this.codigoOS) //antiga rota : retornarServicosUsuarioOs
          .then(rsp => {
            console.log("rsp de chamar codigo os:", rsp);
            if (rsp.status == 200) {
              console.log('-------')
              console.log(rsp)
              if (rsp.data == 1) {
                this.TextoModalHeadline.texto =
                  "Código não encontrado. Tente novamente";
                this.TextoModalHeadline.class = "red lighten-2";
              } else if (rsp.data == 2) {
                this.TextoModalHeadline.texto =
                  "O.S cadastrada em outra unidade !";
                this.TextoModalHeadline.class = "red lighten-2";
              } else if (rsp.data == 3) {
                this.TextoModalHeadline.texto =
                  "O.S cadastrada em outra data !";
                this.TextoModalHeadline.class = "red lighten-2";
              } else {
                // console.log('Entrou aqui')
                this.anoNascimento = null
                if (rsp.data.anoNascimento) {
                  this.anoNascimento = rsp.data.anoNascimento
                  this.dados = rsp.data
                  this.validarAnoNascimento()
                } else {
                  this.servicos = this.dados.servicos;
                  this.exibiuDialogProximasUnidades = false;
                  this.numeroPaciente =
                  this.dados.celular == null ? "00000000000" : this.dados.celular;
                  this.nomePaciente = this.dados.nome;
                  this.listaExamesNaoEncontrados = this.dados.examesNaoEncontrados;
                  this.idPaciente = this.dados.idPaciente;
                  //this.organizarDadosInterfacePreferencia()
                  this.anoNascimento = null
                  // this.mAnoNascimento = null
                  this.retornarMedicosOs();
                }

              }
              this.blockMethod = false;
              this.servicosOsLoading = false;
            } else {
              // console.log('Entrou aqui 2')
              this.blockMethod = false;
              this.servicosOsLoading = false;
              this.TextoModalHeadline.texto =
                "Ocorreu um erro. Tente novamente";
              this.TextoModalHeadline.class = "red lighten-2";
            }
          })
          .catch(err => {
            console.log("error.......");
            this.blockMethod = false;
            this.TextoModalHeadline.texto = "Ocorreu um erro. Tente novamente";
            this.TextoModalHeadline.class = "red lighten-2";
            console.log(err);
          });
      } 
    }, */

    validarAnoNascimento() {
      console.log(this.anoNascimento);
      // console.log(this.anoNascimento === parseInt(this.mAnoNascimento));
      if (this.anoNascimento === parseInt(this.mAnoNascimento)) {
        this.servicos = this.dados.servicos;
        this.exibiuDialogProximasUnidades = false;
        this.numeroPaciente =
          this.dados.celular == null ? "00000000000" : this.dados.celular;
        this.nomePaciente = this.dados.nome;
        this.dataNascimentoPaciente = this.dados.dataNascimento
        this.listaExamesNaoEncontrados = this.dados.examesNaoEncontrados;
        this.idPaciente = this.dados.idPaciente;
        this.idExamesos = this.dados.idExamesos;
        //this.organizarDadosInterfacePreferencia()
        this.anoNascimento = null
        this.servicosOsOk = true
        this.retornarMedicosOs();
      } else {
        this.servicosOsErro.isErro = true
        this.servicosOsErro.tipo = "5";
        this.TextoModalHeadline.texto =
          `Ano incorreto. Tente novamente.`;
        this.TextoModalHeadline.class = "red lighten-2";
      }
    },

    retornarPrioridade() {
      recepcionistaService.recepcionista
        .retornarPrioridade()
        .then(rsp => {
          console.log("rsp retornarPrioridade", rsp.data);
          this.variavelPrioridade = rsp.data.prioridade;
          this.variavelPrioridadeEspecial = rsp.data.prioridadeEspecial;
        })
        .catch(err => {
          //handle your error here
          console.log(err);
        });
    },

    retornarAtendimentos() {
      recepcionistaService.recepcionista
        .retornarAtendimentos()
        .then(rsp => {
          console.log("rsp retornarAtendimentos:", rsp.data);
          this.listaAtendimentos = rsp.data;
          this.listaPrioridade = [];
          this.listaSemPrioridade = [];
          this.listaPendentes = [];
          this.listaNaoCompareceu = [];
          console.log("lista geral..");
          console.log(this.listaAtendimentos);

          this.listaAtendimentos.forEach(atendimento => {
            if (
              (atendimento.prioridade == 0 && atendimento.status == 1) ||
              (atendimento.prioridade == 2 && atendimento.status == 1)
            ) {
              if (this.verificarAtendimento(atendimento)) {
                this.listaSemPrioridade.push(atendimento);
              }
            }
            if (
              (atendimento.prioridade == 1 && atendimento.status == 1) ||
              (atendimento.prioridade == 3 && atendimento.status == 1)
            ) {
              if (this.verificarAtendimento(atendimento)) {
                this.listaPrioridade.push(atendimento);
              }
            }
            if (atendimento.status == 2) {
              this.listaPendentes.push(atendimento);
            }
            if (atendimento.status == 3) {
              this.listaNaoCompareceu.push(atendimento);
            }
          });
        })
        .catch(err => {
          // handle your error here
          console.log("erro catch");
          console.log(err);
        });
    },

    chamarSocket() {

      this.socket.on(
        "connect",
        function (mensagem) {
          console.log('--------- socket');
          this.mensagemNotificacaoSocket = "conectado";
          this.chamarModalConexao();
        }.bind(this)
      );

      this.socket.on("connect_error", () => {
        this.mensagemNotificacaoSocket = "aguardando conexao";
        this.chamarModalConexao();
      });

      this.socket.on(
        "disconnect",
        function () {
          this.mensagemNotificacaoSocket = "desconectado";
          this.chamarModalConexao();
        }.bind(this)
      );

      this.socket.on(
        "medicoOffline",
        function (mensagem) {
          console.log("skt medicoOffline", mensagem);

          this.medicos.forEach(medico => {
            if (medico.idMedico == mensagem) {
              medico.online = 0;
              medico.icone = "clear";
            }
          });
          //this.medicos = medicosAux
        }.bind(this)
      );

      this.socket.on(
        "chamadaNaoAtendida",
        function (atendimento) {
          console.log('é ELE: ', atendimento)
          this.listaSemPrioridade.forEach(
            function (element, index) {

              if (element.codigo === atendimento.codigo) {
                this.listaSemPrioridade.splice(index, 1);
                return;
              }

            }.bind(this)
          );

          this.listaPrioridade.forEach(
            function (element, index) {
              if (element.codigo === atendimento.codigo) {
                this.listaPrioridade.splice(index, 1);
                return;
              }

            }.bind(this)
          );
          var isAtendimento = false
          this.listaNaoCompareceu.forEach(
            function (element, index) {
              if (element.codigo === atendimento.codigo) {
                isAtendimento = true
                return;
              }
            }.bind(this)
          );
          console.log("skt chamada n atendida..");
          console.log(atendimento);
          atendimento.status = 3;
          if (!isAtendimento) this.listaNaoCompareceu.push(atendimento);
        }.bind(this)
      );

      this.socket.on(
        "novoAtendimento",
        function (atendimento) {
          console.log("skt novoAtendimento", atendimento);

          if (atendimento.atendimentoTransferido) {
            console.log("tranferido..");
            if (this.verificarAtendimento(atendimento)) {
              if (atendimento.prioridade == 0 || atendimento.prioridade == 2) {
                var index = this.listaSemPrioridade.findIndex(
                  element => element.codigo > atendimento.codigo
                );
                // console.log(index);
                if (index == -1) {
                  this.listaSemPrioridade.push(atendimento);
                } else {
                  this.listaSemPrioridade.splice(index, 0, atendimento);
                }
              }

              if (atendimento.prioridade == 1 || atendimento.prioridade == 3) {
                var index = this.listaPrioridade.findIndex(
                  element => element.codigo > atendimento.codigo
                );
                console.log(index);
                if (index == -1) {
                  this.listaPrioridade.push(atendimento);
                } else {
                  this.listaPrioridade.splice(index, 0, atendimento);
                }
              }
            }
          } else {
            if (this.verificarAtendimento(atendimento)) {
              if (atendimento.prioridade == 0 || atendimento.prioridade == 2) {
                this.listaSemPrioridade.push(atendimento);
              }
              if (atendimento.prioridade == 1 || atendimento.prioridade == 3) {
                this.listaPrioridade.push(atendimento);
              }
            }
          }
          this.addQuantTabelaConsultas(atendimento);
        }.bind(this)
      );

      this.socket.on(
        "chamando",
        function (mensagem) {
          console.log("skt chamando..", mensagem);

          this.listaSemPrioridade.forEach(
            function (element, index) {

              if (element.codigo == mensagem.codigo) {
                //if (element.codigo == mensagem.codigo) {
                this.subQuantTabelaConsultas(element);
                this.listaSemPrioridade.splice(index, 1);
                this.alterarVariavelPrioridade();
                return;
              }

            }.bind(this)
          );

          this.listaPrioridade.forEach(
            function (element, index) {
              if (element.codigo == mensagem.codigo) {
                //if (element.codigo == mensagem.codigo) {
                this.subQuantTabelaConsultas(element);
                this.listaPrioridade.splice(index, 1);
                this.alterarVariavelPrioridade();
                return;
              }

            }.bind(this)
          );

          this.listaNaoCompareceu.forEach(
            function (element, index) {

              if (element.codigo == mensagem.codigo && (element.codigo != this.atendimento.codigo || this.guiche != mensagem.guiche)) {
                this.listaNaoCompareceu.splice(index, 1);
                return;
              }
            }.bind(this)
          );
        }.bind(this)
      );


    },

    alterarVariavelPrioridade() {
      //if (!this.fezChamada) {
      console.log("altera prioridade");
      if (this.variavelPrioridade == 0) {
        this.variavelPrioridade = 3;
      } else {
        this.variavelPrioridade = this.variavelPrioridade - 1;
      }
      // }
    },

    alterarVariavelPrioridadeEspecial() {
      //if (!this.fezChamada){
      console.log("altera prioridade especial");
      if (this.variavelPrioridadeEspecial == 0) {
        this.variavelPrioridadeEspecial = 3;
      } else {
        this.variavelPrioridadeEspecial = this.variavelPrioridadeEspecial - 1;
      }
      // }
    },

    converterDate(data) {
      var d = new Date(data);
      var minutes = d.getMinutes().toString();
      minutes = minutes.length == 1 ? "0" + minutes : minutes;
      var hours = d.getHours().toString();
      hours = hours.length == 1 ? "0" + hours : hours;

      return hours + ":" + minutes;
    },

    addAtendimento(item, idList) {
      console.log(item);

      if (this.fezChamada) {
        this.dialogErroMudarLocal = true;
        return;
      }
      if (idList == 2) {
        this.isPendente = true;
      } else {
        this.isPendente = false;
      }
      console.log("atendimento", this.item);

      this.fezChamada = false;
      this.iniciouAtendimento = false;
      this.atendimento.codigo = item.codigo;
      this.atendimento.idServico = item.idServico;
      this.atendimento.nomeEspecialidade = item.nomeEspecialidade;
      this.atendimento.prioridade = item.prioridade;
      this.atendimento.codigoSigla = item.codigoSigla
      this.atendimento.idAtendimento = item.idAtendimento;
      this.atendimento.dataChegada = item.dataChegada;
      this.atendimento.prioridadeServico = item.prioridadeServico;
      this.atendimento.dataStatus = item.dataStatus;
      this.atendimento.servicos = item.servicos;
      this.isAtendimentoComp = true
    },

    fazerChamada() {
      this.desabilitaBotaoChamar = true;
      //Re-enable after 6 seconds
      this.timeout = setTimeout(() => {
        this.desabilitaBotaoChamar = false;
      }, 10 * 1000);
      // console.log('-----> ', this.atendimento)

      recepcionistaService.recepcionista
        .fazerChamada(
          this.atendimento.idAtendimento,
          this.atendimento.codigo,
          this.atendimento.codigoSigla,
          this.guiche,
          this.atendimento.prioridade
        )
        .then(rsp => {
          console.log("rsp fazerChamada", rsp);

          if (rsp.data == true) {
            this.fezChamada = true;
            // this.listaPendentes.forEach((element, index) => {
            //   if (element.codigo == this.atendimento.codigo) {
            //     this.listaPendentes.splice(index, 1);
            //   }
            // });
          } else {
            this.dialogCodigo = this.dialogCodigo + 1
            this.dialogChamadaJaFeita = true;
          }
        })
        .catch(err => {
          // handle your error here
          console.log(err);
        });
    },

    chamadaNaoAtendida() {
      //console.log('teste', this.atendimento.servicos)
      console.log('chamada nao atendida: ', atendimento)
      recepcionistaService.recepcionista
        .chamadaNaoAtendida(
          this.atendimento.idAtendimento,
          this.atendimento.codigo,
          this.atendimento.nomeEspecialidade,
          this.atendimento.idServico,
          this.atendimento.prioridade,
          this.atendimento.servicos,
          this.atendimento.dataChegada

        )
        .then(rsp => {
          console.log("rsp chamadaNaoAtendida:", rsp);
          if (rsp.data == true) {
            this.listaPendentes.forEach((element, index) => {
              if (element.codigo == this.atendimento.codigo) {
                //this.subQuantTabelaConsultas(this.atendimento) // add agora
                this.listaPendentes.splice(index, 1);
              }
            });
            this.isPendente = false;
            this.fezChamada = false;
            this.iniciouAtendimento = false;
            this.atendimento.codigo = "";
            this.atendimento.prioridade = "";
            this.atendimento.nomeEspecialidade = "";
            this.atendimento.dataChegada = "";
            this.atendimento.servicos = [];
            this.isAtendimentoComp = false
          }
        })
        .catch(err => {
          // handle your error here
          console.log(err);
        });

    },

    timeDurationToString(duration) {
      return duration > 9 ? duration : "0" + duration;
    },

    iniciarCronometroAtendimento() {
      this.seconds += 1;
      const minutesLeft = Math.floor(this.seconds / 60);
      const secondsLeft = this.seconds % 60;
      this.tempoAtendimento =
        this.timeDurationToString(minutesLeft) +
        " : " +
        this.timeDurationToString(secondsLeft);
    },

    iniciarAtendimento() {
      console.log("Chamou em HomeRecepcionista")
      if (!this.blockMethod) {

        this.blockMethod = true;

        this.seconds = 0 * 60;
        this.tempoAtendimento = "00 : 00";
        this.TextoModalHeadline.texto = "Código O.S";
        this.TextoModalHeadline.class = "blue";
        this.codigoOS = "";

        recepcionistaService.recepcionista
          .iniciarAtendimento(
            this.atendimento.codigo,
            this.atendimento.idAtendimento
          )
          .then(rsp => {
            console.log("rsp iniciarAtendimento:", rsp.data);
            if (rsp.data == true) {
              this.listaPendentes.forEach((element, index) => {
                if (element.codigo == this.atendimento.codigo) {
                  this.listaPendentes.splice(index, 1);
                }
              });
              this.dialogCronometroAtendimento = true;
              var i1 = setInterval(
                () => this.iniciarCronometroAtendimento(),
                1000
              );
              this.intervalos.push(i1);
              this.blockMethod = false;
            }
          }).finally(() => {
            this.listaNaoCompareceu.forEach(
              function (element, index) {
                if (element.codigo == this.atendimento.codigo) {
                  this.listaNaoCompareceu.splice(index, 1);
                }
                return;
              }.bind(this)
            );
            this.listaSemPrioridade.forEach(
              function (element, index) {
                if (element.codigo == this.atendimento.codigo) {
                  this.listaSemPrioridade.splice(index, 1);
                }
                return;
              }.bind(this)
            );
            this.listaPrioridade.forEach(
              function (element, index) {
                if (element.codigo == this.atendimento.codigo) {
                  this.listaPrioridade.splice(index, 1);
                }
                return;
              }.bind(this)
            );
          })
          .catch(err => {
            // handle your error here
            console.log("erro. caiu no cath");
            this.blockMethod = false;
            console.log(err);
          });
      }
    },

    proximoAtendimento() {
      this.dialogProximoAtendimento = false
      this.isAtendimentoComp = false
      this.servicosOsOk = false
      this.tempoAtendimento = '00 : 00'
    },

    examesNaoEncontrados() {
      var quantAux = this.user.quantAtendimentos + 1;
      this.$store.dispatch("QuantAtendimentos", quantAux);
      this.quantAtendimentos = quantAux;
      this.dialogOs = false;
      this.dialogOrdenarExames = false;
      this.fezChamada = false;
      this.atendimento.codigo = "";
      this.atendimento.servicos = [];
      this.atendimento.nomeEspecialidade = "";
      this.atendimento.prioridade = "";
    },

    encerrarAtendimentoExameNaoEncontrado() {
      console.log("[LOG FRONT HomeRecepcionista] Iniciando encerrarAtendimentoExameNaoEncontrado");
      console.log("[LOG FRONT HomeRecepcionista] params:", {
        idAtendimento: this.atendimento.idAtendimento,
        codigoOS: this.codigoOS,
        nomePaciente: this.nomePaciente,
        numeroPaciente: this.numeroPaciente,
        idPaciente: this.idPaciente,
        idExamesos: this.idExamesos
      });
      recepcionistaService.recepcionista
        .encerrarAtendimentoExameNaoEncontrado(
          this.atendimento.idAtendimento,
          this.codigoOS,
          this.nomePaciente,
          this.numeroPaciente,
          this.idPaciente,
          this.idExamesos
        )
        .then(rsp => {
          console.log("[LOG FRONT HomeRecepcionista] rsp encerrarAtendimentoExamesNaoEncontrado:", rsp);
          if (rsp.data == true) {
            console.log("entrou no true");
            var quantAux = this.user.quantAtendimentos + 1;
            this.$store.dispatch("QuantAtendimentos", quantAux);
            this.quantAtendimentos = quantAux;
            this.dialogOs = false;
            this.dialogOrdenarExames = false;
            this.fezChamada = false;
            this.isPendente = false;
            this.atendimento.codigo = "";
            this.atendimento.servicos = [];
            this.atendimento.nomeEspecialidade = "";
            this.atendimento.prioridade = "";
            this.servicosOsOk = false;
            this.isAtendimentoComp = false;
            this.verificarTempoAtendimento(false);
          }
        })
        .catch(err => {
          // handle your error here
          console.log(err);
        });
    },

    encerrarAtendimento() {
      // quem pega é o medico
      console.log("[LOG FRONT HomeRecepcionista] Iniciando encerrarAtendimento");
      console.log("[LOG FRONT HomeRecepcionista] params:", {
        idAtendimento: this.atendimento.idAtendimento,
        codigo: this.atendimento.codigo,
        prioridade: this.atendimento.prioridade,
        nomePaciente: this.nomePaciente,
        numeroPaciente: this.numeroPaciente,
        idPaciente: this.idPaciente,
        idExamesos: this.idExamesos,
        idMedico: this.idMedico,
        consultasCount: this.consultas ? this.consultas.length : 0,
        dataNascimentoPaciente: this.dataNascimentoPaciente
      });
      this.iniciouAtendimento = false;

      recepcionistaService.recepcionista
        .encerrarAtendimento(
          this.atendimento.idAtendimento,
          this.atendimento.codigo,
          this.atendimento.prioridade,
          this.nomePaciente,
          this.numeroPaciente,
          this.idPaciente,
          this.idExamesos,
          this.idMedico,
          this.consultas,
          this.dataNascimentoPaciente
        )
        .then(rsp => {
          console.log("[LOG FRONT HomeRecepcionista] rsp encerrarAtendimento:", rsp);
          if (rsp.data == true) {
            var quantAux = this.user.quantAtendimentos + 1;
            this.$store.dispatch("QuantAtendimentos", quantAux);
            this.quantAtendimentos = quantAux;
            this.fezChamada = false;
            this.atendimento.codigo = "";
            this.atendimento.servicos = [];
            this.atendimento.nomeEspecialidade = "";
            this.atendimento.prioridade = "";
            this.numeroPaciente = "";
            this.verificarTempoAtendimento(true);
          }
        })
        .catch(err => {
          console.log("erro. caiu no cath");
          console.log(err);
        });
    },

    verificarTempoAtendimento(bool) {
      if (bool) {
        if (this.seconds < 30 && this.quantVerificarTempoAtendimento < 2) {
          this.quantVerificarTempoAtendimento++;
          setTimeout(
            function () {
              this.dialogAvisoAtendimento = true;
            }.bind(this),
            6000
          );
        }
      }
      if (!bool) {
        if (this.seconds < 30 && this.quantVerificarTempoAtendimento < 2) {
          this.quantVerificarTempoAtendimento++;
          this.dialogAvisoAtendimento = true;
        }
      }
    },

    setarGuiche() {
      console.log("em setar guiche...", this.guicheSelecionado);
      this.$store.dispatch("Guiche", this.guicheSelecionado);
      this.guiche = this.guicheSelecionado;
    },

    retornarServicos() {
      console.log("retornar Serviços...");
      recepcionistaService.recepcionista
        .retornarServicos(this.user.idLocal)
        .then(rsp => {
          console.log("rsp de retornarServicos:", rsp);
          if (rsp.data != false) {
            var rsp = rsp.data;
            this.listaTabelaServicos = rsp.map(element => ({
              ...element,
              status: false
            }));
            this.listaTransferirAtendimentosMedicos = this.listaTabelaServicos.filter(
              element => element.atendimentoMedico == 0
            );
            if (this.user.servicosRecepcionista) {
              this.listaServicosRecepcionista = this.user.servicosRecepcionista;
            } else {
              this.$store.dispatch(
                "ServicosRecepcionista",
                this.listaTabelaServicos
              );
              this.listaServicosRecepcionista = this.listaTabelaServicos;
            }
            this.retornarAtendimentos();
            this.retornarQuantConsultas();
          }
        })
        .catch(err => {
          // handle your error here
          console.log(err);
        });
    },

    retornarQuantConsultas() {
      console.log("retorn qnt consultas");
      recepcionistaService.recepcionista
        .retornarQuantConsultas(this.user.idLocal)
        .then(rsp => {
          console.log("rsp de retorn qnt consultas:", rsp);
          this.listaQuantConsultas = rsp.data;
          this.montarTabelaServico();
          this.desserts = this.itensTabelaConsultas;
        })
        .catch(err => {
          // handle your error here
          console.log(err);
        });
    },

    setarMedico(index) {
      console.log("setar Unidade", index);
      console.log("agrupa apos", this.listaServicosAgrupados);
    },

    logout() {
      console.log("em logout..");
      //this.$router.push("/login");
      this.$store
        .dispatch("FedLogOut")
        .then(rsp => {
          console.log("11111111");

          this.socket ? this.socket.close() : "";
          this.limparIntervalos();
          this.$router.push("/login");
        })
        .catch(error => {
          //this.progress = false;
          //this.alert = true;
          //this.msg = error;
        });
    },

    groupBy(collection, property) {
      var i = 0,
        val,
        index,
        values = [],
        result = [];
      for (; i < collection.length; i++) {
        val = collection[i][property];
        index = values.indexOf(val);
        if (index > -1) result[index].push(collection[i]);
        else {
          values.push(val);
          result.push([collection[i]]);
        }
      }
      return result;
    },

    chamarModalConexao() {
      console.log("em chamarModalConexao..");

      if (this.mensagemNotificacaoSocket == "aguardando conexao") {
        console.log("em if aguard conex");
        this.aguardandoConexao = true;
        this.entrouEmAguardandoConexao = true;
      }
      if (this.mensagemNotificacaoSocket == "conectado") {
        this.aguardandoConexao = false;
        if (this.entrouEmAguardandoConexao) {
          this.retornarAtendimentos();
          this.entrouEmAguardandoConexao = false;
        }
      } else if (this.mensagemNotificacaoSocket == "desconectado") {
        this.aguardandoConexao = true;
      }
    },
    fecharAlertErro() {
      // Alert Erro em cadastro OS
      this.servicosOsErro.isErro = false
      this.servicosOsErro.tipo = " "
    },
    exibirCardOS() {
      this.dialogOs = true
    },
    fecharCardOS() {
      this.dialogOs = false
    },


  },

  mounted() {
    setTimeout(
      function () {
        this.alert = false;
      }.bind(this),
      20000
    );

    console.log("imprimindo user...", this.user);
    if (this.user.tipo != 2) {
      this.$router.push("/login");
      return;
    }
    //this.retornarHelp()
    this.retornarServicos();
    this.socket = io.connect(socketService.SOCKET_URL, {
      query: {
        token: getToken()
      }
    });

    this.chamarSocket();
    //console.log("imprimindo user...", this.user.guiche);
    this.guiche = !this.user.guiche ? "?" : this.user.guiche;

    if (!this.user.idLocal) {
      // console.log("imprimindo user...", this.user.guiche);
      this.dialogPrimeiroAcesso = true;
      return;
    } else {

      this.idLocalEscolhido = this.user.idLocal;
      this.nomeLocal = this.user.nomeLocal;
      this.localEscolhido = this.nomeLocal;
      this.quantAtendimentos = this.user.quantAtendimentos;
      this.retornarPrioridade();
      // this.retornarMedicos();
      this.tamListaAtendimentos = this.listaServicosPrioridade.length;
    }

    document.body.addEventListener("keyup", e => {
      if (this.user.tipo == 2 && !this.enterblock) {
        if (this.dialogOrdenarExames && e.keyCode === 13) {
          this.addUnidadesServicos();
        } else if (this.dialogCadastrarPreferencia && e.keyCode === 13) {
          if (this.step < this.listaServicosAgrupados.length - 1) {
            this.somarStep();
          } else if (
            this.verificaNumeroTelefone() &&
            !this.desabilitaBotaoAdicionar
          ) {
            this.enterblock = true;
            setTimeout(
              function () {
                this.enterblock = false;
              }.bind(this),
              5000
            );
            this.organizarServicosEnviados();
          }
        }
      }
    });
    this.retornarUnidades()
  }
};
</script>

<style scoped>
.tile {
  margin: 5px;
  border-radius: 4px;
  background: rgb(240, 133, 133);
}

.pulse {
  animation: pulse 1s infinite;
}

.pulse:hover {
  animation: 0ms;
}

@keyframes pulse {
  0% {
    -moz-box-shadow: 0 0 0 0 rgba(204, 169, 44, 0.4);
    box-shadow: 0 0 0 0 rgba(204, 169, 44, 0.4);
  }

  70% {
    -moz-box-shadow: 0 0 0 10px rgba(204, 44, 44, 0);
    box-shadow: 0 0 0 10px rgba(204, 169, 44, 0);
  }

  100% {
    -moz-box-shadow: 0 0 0 0 red(0, 0, 0, 0);
    box-shadow: 0 0 0 0 red(204, 169, 44, 0);
  }
}

.rounded-card {
  border-radius: 20px;
}

.cronometro {
  font-family: "Teko", sans-serif;
  font-size: 90px;
}

.flip-list-move {
  transition: transform 0.5s;
}

.v-overflow-btn .v-input__slot::before {
  border-color: grey !important;
}

.scrollable {
  overflow-y: scroll;
}
</style>
